export const banks = {
    '0040': 'Nordea',
    '0041': 'Nordea',
    '0042': 'Nordea',
    '0043': 'Nordea',
    '0044': 'Nordea',
    '0045': 'Nordea',
    '0046': 'Nordea',
    '0047': 'Nordea',
    '0048': 'Nordea',
    '0051': 'Nordea',
    '0052': 'Nordea',
    '0053': 'Nordea',
    '0056': 'Nordea',
    '0057': 'Nordea',
    '0059': 'Nordea',
    '0101': 'Nordea',
    '0102': 'Nordea',
    '0103': 'Nordea',
    '0104': 'Nordea',
    '0105': 'Nordea',
    '0106': 'Nordea',
    '0107': 'Nordea',
    '0108': 'Nordea',
    '0109': 'Nordea',
    '0110': 'Nordea',
    '0111': 'Nordea',
    '0113': 'Nordea',
    '0114': 'Nordea',
    '0115': 'Nordea',
    '0116': 'Nordea',
    '0117': 'Nordea',
    '0118': 'Nordea',
    '0119': 'Nordea',
    '0120': 'Nordea',
    '0121': 'Nordea',
    '0122': 'Nordea',
    '0123': 'Nordea',
    '0124': 'Nordea',
    '0125': 'Nordea',
    '0126': 'Nordea',
    '0127': 'Nordea',
    '0128': 'Nordea',
    '0129': 'Nordea',
    '0130': 'Nordea',
    '0131': 'Nordea',
    '0132': 'Nordea',
    '0133': 'Nordea',
    '0134': 'Nordea',
    '0135': 'Nordea',
    '0136': 'Nordea',
    '0137': 'Nordea',
    '0138': 'Nordea',
    '0139': 'Nordea',
    '0140': 'Nordea',
    '0141': 'Nordea',
    '0142': 'Nordea',
    '0143': 'Nordea',
    '0144': 'Nordea',
    '0145': 'Nordea',
    '0146': 'Nordea',
    '0148': 'Nordea',
    '0149': 'Nordea',
    '0150': 'Nordea',
    '0151': 'Nordea',
    '0152': 'Nordea',
    '0154': 'Nordea',
    '0155': 'Nordea',
    '0156': 'Nordea',
    '0157': 'Nordea',
    '0158': 'Nordea',
    '0159': 'Nordea',
    '0160': 'Nordea',
    '0161': 'Nordea',
    '0163': 'Nordea',
    '0164': 'Nordea',
    '0165': 'Nordea',
    '0166': 'Nordea',
    '0167': 'Nordea',
    '0168': 'Nordea',
    '0169': 'Nordea',
    '0170': 'Nordea',
    '0171': 'Nordea',
    '0172': 'Nordea',
    '0173': 'Nordea',
    '0174': 'Nordea',
    '0175': 'Nordea',
    '0176': 'Nordea',
    '0177': 'Nordea',
    '0178': 'Nordea',
    '0179': 'Nordea',
    '0180': 'Nordea',
    '0181': 'Nordea',
    '0182': 'Nordea',
    '0183': 'Nordea',
    '0184': 'Nordea',
    '0185': 'Nordea',
    '0186': 'Nordea',
    '0187': 'Nordea',
    '0190': 'Nordea',
    '0191': 'Nordea',
    '0194': 'Nordea',
    '0198': 'Nordea',
    '0200': 'Danske Bank',
    '0216': 'Danske Bank',
    '0220': 'Danske Bank',
    '0222': 'Danske Bank',
    '0225': 'Danske Bank',
    '0227': 'Danske Bank',
    '0233': 'Danske Bank',
    '0238': 'Danske Bank',
    '0239': 'Danske Bank',
    '0241': 'Danske Bank',
    '0242': 'Danske Bank',
    '0246': 'Danske Bank',
    '0247': 'Danske Bank',
    '0248': 'Danske Bank',
    '0249': 'Danske Bank',
    '0250': 'Danske Bank',
    '0252': 'Danske Bank',
    '0254': 'Danske Bank',
    '0255': 'Danske Bank',
    '0258': 'Danske Bank',
    '0259': 'Danske Bank',
    '0260': 'Danske Bank',
    '0261': 'Danske Bank',
    '0263': 'Danske Bank',
    '0264': 'Danske Bank',
    '0265': 'Danske Bank',
    '0266': 'Danske Bank',
    '0268': 'Danske Bank',
    '0270': 'Danske Bank',
    '0271': 'Danske Bank',
    '0272': 'Danske Bank',
    '0274': 'Danske Bank',
    '0275': 'Danske Bank',
    '0276': 'Danske Bank',
    '0280': 'Danske Bank',
    '0283': 'Danske Bank',
    '0284': 'Danske Bank',
    '0294': 'Danske Bank',
    '0297': 'Danske Bank',
    '0301': 'Nordea',
    '0303': 'Nordea',
    '0306': 'Nordea',
    '0307': 'Nordea',
    '0308': 'Nordea',
    '0309': 'Nordea',
    '0311': 'Nordea',
    '0312': 'Nordea',
    '0314': 'Nordea',
    '0315': 'Nordea',
    '0316': 'Nordea',
    '0317': 'Nordea',
    '0319': 'Nordea',
    '0320': 'Nordea',
    '0321': 'Nordea',
    '0322': 'Nordea',
    '0327': 'Nordea',
    '0328': 'Nordea',
    '0329': 'Nordea',
    '0333': 'Nordea',
    '0336': 'Nordea',
    '0337': 'Nordea',
    '0338': 'Nordea',
    '0339': 'Nordea',
    '0340': 'Nordea',
    '0341': 'Nordea',
    '0342': 'Nordea',
    '0343': 'Nordea',
    '0344': 'Nordea',
    '0345': 'Nordea',
    '0346': 'Nordea',
    '0347': 'Nordea',
    '0352': 'Nordea',
    '0354': 'Nordea',
    '0373': 'Nordea',
    '0378': 'Nordea',
    '0379': 'Nordea',
    '0385': 'Nordea',
    '0388': 'Nordea',
    '0390': 'Nordea',
    '0392': 'Nordea',
    '0393': 'Nordea',
    '0400': 'Lån og Spar Bank',
    '0404': 'Lån og Spar Bank',
    '0418': 'Danske Bank',
    '0421': 'Danske Bank',
    '0424': 'Danske Bank',
    '0429': 'Danske Bank',
    '0430': 'Danske Bank',
    '0434': 'Danske Bank',
    '0435': 'Nordea',
    '0440': 'Danske Bank',
    '0443': 'Danske Bank',
    '0452': 'Danske Bank',
    '0454': 'Danske Bank',
    '0455': 'Danske Bank',
    '0465': 'Nordea',
    '0466': 'Nordea',
    '0467': 'Nordea',
    '0468': 'Nordea',
    '0469': 'Nordea',
    '0470': 'Nordea',
    '0471': 'Nordea',
    '0473': 'Nordea',
    '0474': 'Nordea',
    '0480': 'Nordea',
    '0482': 'Danske Bank',
    '0516': 'Sparekassen Sjælland',
    '0517': 'Sparekassen Sjælland',
    '0518': 'Sparekassen Sjælland',
    '0519': 'Sparekassen Sjælland',
    '0520': 'Sparekassen Sjælland',
    '0521': 'Sparekassen Sjælland',
    '0522': 'Sparekassen Sjælland',
    '0523': 'Sparekassen Sjælland',
    '0524': 'Sparekassen Sjælland',
    '0525': 'Sparekassen Sjælland',
    '0526': 'Sparekassen Sjælland',
    '0533': 'Dragsholm Sparekasse',
    '0534': 'Dragsholm Sparekasse',
    '0535': 'Dragsholm Sparekasse',
    '0536': 'Danske Bank',
    '0537': 'Dragsholm Sparekasse',
    '0539': 'Sparekassen Sjælland',
    '0540': 'Sparekassen Sjælland',
    '0541': 'Sparekassen Sjælland',
    '0542': 'Sparekassen Sjælland',
    '0543': 'Sparekassen Sjælland',
    '0544': 'Refnæs Sparekasse',
    '0545': 'Sparekassen Sjælland',
    '0547': 'Dragsholm Sparekasse',
    '0548': 'Danske Bank',
    '0550': 'Sparekassen Sjælland-Fyn',
    '0553': 'Sparekassen Sjælland-Fyn A/S',
    '0561': 'FS Bank',
    '0562': 'Danske Bank',
    '0570': 'Sydbank',
    '0571': 'Danske Bank',
    '0573': 'Danske Bank',
    '0575': 'Danske Bank',
    '0577': 'Flakkebjerg og Omegns Sparekasse',
    '0579': 'Den Lille Bikube',
    '0580': 'Sparekassen Sjælland',
    '0581': 'Munke-Bjergby Bromme Sognes Sparekasse',
    '0582': 'Ikano Bank',
    '0586': 'Lundforlund og Gerlev Sognes Spare- og Laanekasse',
    '0587': 'Marvede Sogns Spare- & Lånekasse',
    '0588': 'Stillinge, Spare- og Laanekassen i',
    '0600': '',
    '0601': 'Nordea',
    '0602': 'Nordea',
    '0603': 'Nordea',
    '0604': 'Nordea',
    '0605': 'Nordea',
    '0607': 'Nordea',
    '0608': 'Nordea',
    '0612': 'Danske Bank',
    '0614': 'Danske Bank',
    '0616': 'Danske Bank',
    '0618': 'Danske Bank',
    '0619': 'Danske Bank',
    '0620': 'Danske Bank',
    '0622': 'Danske Bank',
    '0624': 'Danske Bank',
    '0629': 'Danske Bank',
    '0630': 'Danske Bank',
    '0631': 'Kongsted Sparekasse',
    '0634': 'Snesere Sogns Spare- og Laanekasse',
    '0637': 'Nordea',
    '0644': 'Møns Bank',
    '0646': 'Nordea',
    '0647': 'Nordea',
    '0648': 'Nordea',
    '0649': 'Nordea',
    '0650': 'Nordea',
    '0651': 'Nordea',
    '0653': 'Nordea',
    '0654': 'Nordea',
    '0655': 'Nordea',
    '0656': 'Nordea',
    '0657': 'Nordea',
    '0658': 'Nordea',
    '0659': 'Nordea',
    '0660': 'Nordea',
    '0661': 'Nordea',
    '0662': 'Nordea',
    '0670': 'Nordea',
    '0672': 'Nordea',
    '0673': 'Nordea',
    '0674': 'Nordea',
    '0675': 'Nordea',
    '0676': 'Nordea',
    '0677': 'Nordea',
    '0678': 'Nordea',
    '0679': 'Nordea',
    '0680': 'Nordea',
    '0681': 'Jyske Bank',
    '0682': 'Jyske Bank',
    '0683': 'Jyske Bank',
    '0684': 'Jyske Bank',
    '0685': 'Jyske Bank',
    '0686': 'Jyske Bank',
    '0687': 'Jyske Bank',
    '0688': 'Jyske Bank',
    '0689': 'Jyske Bank',
    '0690': 'Jyske Bank',
    '0691': 'Jyske Bank',
    '0692': 'Jyske Bank',
    '0693': 'Jyske Bank',
    '0694': 'Jyske Bank',
    '0696': 'Jyske Bank',
    '0697': 'Jyske Bank',
    '0704': 'Jyske Bank',
    '0705': 'Jyske Bank',
    '0706': 'Nordea',
    '0708': 'Nordea',
    '0710': 'Nordea',
    '0711': 'Nordea',
    '0712': 'Nordea',
    '0713': 'Nordea',
    '0719': 'Danske Bank',
    '0725': 'FS Bank',
    '0735': 'Nordea',
    '0740': 'Nordea',
    '0745': 'Nordea',
    '0750': 'Nordea',
    '0751': 'FS Bank',
    '0755': 'Middelfart Sparekasse',
    '0756': 'Middelfart Sparekasse',
    '0757': 'Middelfart Sparekasse',
    '0758': 'Middelfart Sparekasse',
    '0759': 'Middelfart Sparekasse',
    '0762': 'Nordea',
    '0763': 'FS Bank',
    '0766': 'Nordea',
    '0767': 'Nordea',
    '0773': 'Nordea',
    '0774': 'Nordea',
    '0775': 'Nordea',
    '0776': 'Nordea',
    '0777': 'Nordea',
    '0778': 'Nordea',
    '0779': 'Nordea',
    '0784': 'Nordea',
    '0785': 'Nordea',
    '0787': 'Nordea',
    '0788': 'Nordea',
    '0790': 'Nordea',
    '0791': 'Nordea',
    '0798': 'Nordea',
    '0800': 'Flemløse Sparekasse',
    '0802': 'Nordea',
    '0808': 'Nordea',
    '0809': 'Nordea',
    '0810': 'Nordea',
    '0811': 'Nordea',
    '0812': 'Nordea',
    '0813': 'Svendborg Sparekasse',
    '0814': 'Svendborg Sparekasse',
    '0815': 'Fynske Bank',
    '0816': 'Svendborg Sparekasse',
    '0817': 'Svendborg Sparekasse',
    '0818': 'Svendborg Sparekasse',
    '0819': 'Svendborg Sparekasse',
    '0820': 'Svendborg Sparekasse',
    '0821': 'Nordea',
    '0823': 'Nordea',
    '0824': 'FS Bank',
    '0825': 'Nordea',
    '0826': 'Nordea',
    '0827': 'Nordea',
    '0828': 'Sparekassen Sjælland-Fyn',
    '0831': 'Nordea',
    '0834': 'Nordea',
    '0835': 'Nordea',
    '0836': 'Nordea',
    '0837': 'Nordea',
    '0838': 'Nordea',
    '0839': 'Nordea',
    '0840': 'Nordea',
    '0841': 'Nordea',
    '0842': 'Nordea',
    '0843': 'Nordea',
    '0844': 'Svendborg Sparekasse',
    '0847': 'Rise Spare- og Lånekasse',
    '0850': 'Nordea',
    '0851': 'Nordea',
    '0852': 'Nordea',
    '0853': 'Nordea',
    '0854': 'Nordea',
    '0855': 'Nordea',
    '0860': 'Svendborg Sparekasse',
    '0861': 'Svendborg Sparekasse',
    '0862': 'Svendborg Sparekasse',
    '0863': 'Svendborg Sparekasse',
    '0864': 'Svendborg Sparekasse',
    '0865': 'Svendborg Sparekasse',
    '0866': 'Sparekassen Kronjylland',
    '0867': 'Den Jyske Sparekasse',
    '0868': 'Den Jyske Sparekasse',
    '0870': 'Den Jyske Sparekasse',
    '0871': 'Den Jyske Sparekasse',
    '0872': 'Den Jyske Sparekasse',
    '0873': 'Den Jyske Sparekasse',
    '0875': 'Ingeniørernes Pensionsbank',
    '0877': 'Middelfart Sparekasse',
    '0878': 'Middelfart Sparekasse',
    '0880': 'Handelsbanken',
    '0881': 'Handelsbanken',
    '0883': 'Handelsbanken',
    '0884': 'Handelsbanken',
    '0888': 'Handelsbanken',
    '0889': 'Handelsbanken',
    '0890': 'Handelsbanken',
    '0891': 'Handelsbanken',
    '0892': 'Handelsbanken',
    '0893': 'Handelsbanken',
    '0894': 'Handelsbanken',
    '0895': 'Handelsbanken',
    '0896': 'Handelsbanken',
    '0897': 'Handelsbanken',
    '0898': 'Handelsbanken',
    '0899': 'Handelsbanken',
    '0903': 'Danske Bank',
    '0904': 'Danske Bank',
    '0905': 'Danske Bank',
    '0906': 'Danske Bank',
    '0907': 'Danske Bank',
    '0908': 'Danske Bank',
    '0909': 'Danske Bank',
    '0910': 'Danske Bank',
    '0913': 'Danske Bank',
    '0914': 'Danske Bank',
    '0917': 'Danske Bank',
    '0918': 'Danske Bank',
    '0922': 'Danske Bank',
    '0924': 'Danske Bank',
    '0925': 'Danske Bank',
    '0928': 'Danske Bank',
    '0930': 'Danske Bank',
    '0933': 'Danske Bank',
    '0939': 'Danske Bank',
    '0940': 'Danske Bank',
    '0941': 'Danske Bank',
    '0942': 'Danske Bank',
    '0948': 'Danske Bank',
    '0952': 'Danske Bank',
    '0954': 'Danske Bank',
    '0964': 'Danske Bank',
    '0971': 'Danske Bank',
    '0972': 'Danske Bank',
    '0974': 'Danske Bank',
    '0975': 'Danske Bank',
    '0976': 'Danske Bank',
    '0977': 'Danske Bank',
    '0978': 'Danske Bank',
    '0979': 'Danske Bank',
    '0980': 'Danske Bank',
    '0981': 'Danske Bank',
    '0982': 'Danske Bank',
    '0983': 'Danske Bank',
    '0985': 'Danske Bank',
    '0987': 'Danske Bank',
    '0988': 'Danske Bank',
    '0989': 'Danske Bank',
    '0991': 'Danske Bank',
    '0993': 'Danske Bank',
    '0994': 'Danske Bank',
    '0996': 'Danske Bank',
    '0998': 'Danske Bank',
    '0999': 'Danske Bank',
    '1001': 'Nationalbanken',
    '1003': 'Nationalbanken',
    '1005': 'Nationalbanken',
    '1011': 'Nationalbanken',
    '1111': 'Nationalbanken',
    '1149': 'Saxo Bank',
    '1171': 'Danske Bank',
    '1172': 'Danske Bank',
    '1187': 'Saxo Privatbank',
    '1199': 'Danske Bank',
    '1202': 'Nordea',
    '1204': 'Nordea',
    '1205': 'Nordea',
    '1206': 'Nordea',
    '1207': 'Nordea',
    '1225': 'Nordea',
    '1307': 'Nordea',
    '1308': 'Nordea',
    '1309': 'Nordea',
    '1310': 'Nordea',
    '1315': 'Nordea',
    '1316': 'Nordea',
    '1317': 'Nordea',
    '1319': 'Nordea',
    '1320': 'Nordea',
    '1321': 'Nordea',
    '1322': 'Nordea',
    '1323': 'Nordea',
    '1324': 'Nordea',
    '1325': 'Nordea',
    '1326': 'Nordea',
    '1328': 'Nordea',
    '1329': 'Nordea',
    '1331': 'Nordea',
    '1332': 'Nordea',
    '1333': 'Nordea',
    '1335': 'Nordea',
    '1340': 'Nordea',
    '1341': 'Nordea',
    '1342': 'Nordea',
    '1343': 'Nordea',
    '1344': 'Nordea',
    '1345': 'Nordea',
    '1347': 'Nordea',
    '1348': 'Nordea',
    '1349': 'Nordea',
    '1350': 'Nordea',
    '1352': 'Nordea',
    '1353': 'Nordea',
    '1355': 'Nordea',
    '1360': 'Nordea',
    '1362': 'Nordea',
    '1364': 'Nordea',
    '1400': 'Nordea',
    '1401': 'Nordea',
    '1402': 'Nordea',
    '1403': 'Nordea',
    '1404': 'Nordea',
    '1405': 'Nordea',
    '1406': 'Nordea',
    '1407': 'Nordea',
    '1418': 'Nordea',
    '1420': 'Nordea',
    '1421': 'Nordea',
    '1422': 'Nordea',
    '1423': 'Nordea',
    '1424': 'Nordea',
    '1425': 'Nordea',
    '1426': 'Nordea',
    '1428': 'Nordea',
    '1429': 'Nordea',
    '1430': 'Nordea',
    '1432': 'Nordea',
    '1433': 'Nordea',
    '1434': 'Nordea',
    '1436': 'Nordea',
    '1437': 'Nordea',
    '1438': 'Nordea',
    '1439': 'Nordea',
    '1471': 'Danske Bank',
    '1479': 'Danske Bank',
    '1481': 'Danske Bank',
    '1482': 'Danske Bank',
    '1492': 'Danske Bank',
    '1498': 'Danske Bank',
    '1501': 'Danske Bank',
    '1505': 'Danske Bank',
    '1506': 'Danske Bank',
    '1507': 'Danske Bank',
    '1510': 'Danske Bank',
    '1511': 'Danske Bank',
    '1513': 'Danske Bank',
    '1515': 'Danske Bank',
    '1517': 'Danske Bank',
    '1519': 'Sparekassen Thy',
    '1520': 'Danske Bank',
    '1521': 'Danske Bank',
    '1525': 'Danske Bank',
    '1527': 'Danske Bank',
    '1532': 'Danske Bank',
    '1533': 'Danske Bank',
    '1535': 'Danske Bank',
    '1536': 'Danske Bank',
    '1543': 'Danske Bank',
    '1546': 'Danske Bank',
    '1548': 'Danske Bank',
    '1550': 'Danske Bank',
    '1551': 'Danske Bank',
    '1552': 'Danske Bank',
    '1559': 'Danske Bank',
    '1560': 'Danske Bank',
    '1562': 'Danske Bank',
    '1563': 'Danske Bank',
    '1564': 'Danske Bank',
    '1567': 'Danske Bank',
    '1569': 'Danske Bank',
    '1570': 'Danske Bank',
    '1577': 'Danske Bank',
    '1579': 'Danske Bank',
    '1584': 'Danske Bank',
    '1588': 'Danske Bank',
    '1594': 'Danske Bank',
    '1597': 'Danske Bank',
    '1599': 'Danske Bank',
    '1601': 'Nuna Bank',
    '1621': 'Danske Bank',
    '1670': 'Danske Bank',
    '1671': 'Basisbank',
    '1681': 'Middelfart Sparekasse',
    '1682': 'Middelfart Sparekasse',
    '1684': 'Middelfart Sparekasse',
    '1685': 'Middelfart Sparekasse',
    '1686': 'Middelfart Sparekasse',
    '1687': 'Middelfart Sparekasse',
    '1688': 'Middelfart Sparekasse',
    '1689': 'Middelfart Sparekasse',
    '1693': 'PFA Udbetalingsbank',
    '1701': 'Nordea',
    '1702': 'Nordea',
    '1703': 'Nordea',
    '1704': 'Nordea',
    '1705': 'Nordea',
    '1706': 'Nordea',
    '1707': 'Nordea',
    '1708': 'Nordea',
    '1709': 'Nordea',
    '1710': 'Nordea',
    '1711': 'Nordea',
    '1714': 'Nordea',
    '1715': 'Nordea',
    '1716': 'Nordea',
    '1717': 'Nordea',
    '1718': 'Nordea',
    '1726': 'Nordea',
    '1727': 'Nordea',
    '1728': 'Nordea',
    '1729': 'Nordea',
    '1730': 'Nordea',
    '1732': 'Nordea',
    '1735': 'Nordea',
    '1738': 'Nordea',
    '1739': 'Nordea',
    '1740': 'Nordea',
    '1742': 'Nordea',
    '1850': 'Nordea',
    '1901': 'Nordea',
    '1905': 'Nordea',
    '1908': 'Nordea',
    '1909': 'Nordea',
    '1910': 'Nordea',
    '1911': 'Nordea',
    '1912': 'Nordea',
    '1913': 'Nordea',
    '1914': 'Nordea',
    '1915': 'Nordea',
    '1916': 'Nordea',
    '1917': 'Nordea',
    '1918': 'Nordea',
    '1919': 'Nordea',
    '1920': 'Nordea',
    '1922': 'Nordea',
    '1924': 'Nordea',
    '1925': 'Nordea',
    '1926': 'Nordea',
    '1927': 'Nordea',
    '1928': 'Nordea',
    '1929': 'Nordea',
    '1930': 'Nordea',
    '1931': 'Nordea',
    '1932': 'Nordea',
    '1933': 'Nordea',
    '1935': 'Nordea',
    '1936': 'Nordea',
    '1938': 'Nordea',
    '1939': 'Nordea',
    '1941': 'Nordea',
    '1944': 'Nordea',
    '1946': 'Nordea',
    '1947': 'Nordea',
    '1948': 'Nordea',
    '1949': 'Nordea',
    '1950': 'Nordea',
    '1951': 'Nordea',
    '1954': 'Nordea',
    '1955': 'Nordea',
    '1957': 'Nordea',
    '1958': 'Nordea',
    '1959': 'Nordea',
    '1969': 'Nordea',
    '1970': 'Nordea',
    '1971': 'Nordea',
    '1973': 'Nordea',
    '1974': 'Nordea',
    '1978': 'Nordea',
    '1980': 'Nordea',
    '1981': 'Nordea',
    '1982': 'Nordea',
    '1984': 'Nordea',
    '1985': 'Nordea',
    '1986': 'Nordea',
    '1987': 'Nordea',
    '1989': 'Nordea',
    '1995': 'Nordea',
    '1996': 'Nordea',
    '1997': 'Nordea',
    '1998': 'Nordea',
    '2000': 'Nordea',
    '2001': 'Nordea',
    '2005': 'Nordea',
    '2006': 'Nordea',
    '2007': 'Nordea',
    '2008': 'Nordea',
    '2009': 'Nordea',
    '2010': 'Nordea',
    '2011': 'Nordea',
    '2012': 'Nordea',
    '2013': 'Nordea',
    '2014': 'Nordea',
    '2015': 'Nordea',
    '2016': 'Nordea',
    '2017': 'Nordea',
    '2018': 'Nordea',
    '2019': 'Nordea',
    '2021': 'Nordea',
    '2022': 'Nordea',
    '2024': 'Nordea',
    '2026': 'Nordea Finans',
    '2027': 'Nordea',
    '2028': 'Nordea',
    '2029': 'Nordea',
    '2030': 'Nordea',
    '2031': 'Nordea',
    '2032': 'Nordea',
    '2033': 'Nordea',
    '2035': 'Nordea',
    '2036': 'Nordea',
    '2037': 'Nordea',
    '2038': 'Nordea',
    '2039': 'Nordea',
    '2040': 'Nordea',
    '2041': 'Nordea',
    '2042': 'Nordea',
    '2043': 'Nordea',
    '2044': 'Nordea',
    '2045': 'Nordea',
    '2046': 'Nordea',
    '2047': 'Nordea',
    '2048': 'Nordea',
    '2049': 'Nordea',
    '2051': 'Nordea',
    '2052': 'Nordea',
    '2053': 'Nordea',
    '2057': 'Nordea',
    '2061': 'Nordea',
    '2062': 'Nordea',
    '2063': 'Nordea',
    '2065': 'Nordea',
    '2066': 'Nordea',
    '2067': 'Nordea',
    '2068': 'Nordea',
    '2069': 'Nordea',
    '2075': 'Nordea',
    '2076': 'Nordea',
    '2077': 'Nordea',
    '2080': 'Nordea',
    '2081': 'Nordea',
    '2082': 'Nordea',
    '2086': 'Nordea',
    '2087': 'Nordea',
    '2088': 'Nordea',
    '2089': 'Nordea',
    '2091': 'Nordea',
    '2093': 'Nordea',
    '2094': 'Nordea',
    '2096': 'Nordea',
    '2097': 'Nordea',
    '2100': 'Nordea',
    '2101': 'Nordea',
    '2102': 'Nordea',
    '2103': 'Nordea',
    '2104': 'Nordea',
    '2105': 'Nordea',
    '2106': 'Nordea',
    '2107': 'Nordea',
    '2108': 'Nordea',
    '2109': 'Nordea',
    '2110': 'Nordea',
    '2111': 'Nordea',
    '2112': 'Nordea',
    '2113': 'Nordea',
    '2114': 'Nordea',
    '2115': 'Nordea',
    '2116': 'Nordea',
    '2117': 'Nordea',
    '2118': 'Nordea',
    '2119': 'Nordea',
    '2120': 'Nordea',
    '2121': 'Nordea',
    '2122': 'Nordea',
    '2123': 'Nordea',
    '2124': 'Nordea',
    '2125': 'Nordea',
    '2126': 'Nordea',
    '2127': 'Nordea',
    '2128': 'Nordea',
    '2129': 'Nordea',
    '2130': 'Nordea',
    '2131': 'Nordea',
    '2132': 'Nordea',
    '2133': 'Nordea',
    '2134': 'Nordea',
    '2135': 'Nordea',
    '2136': 'Nordea',
    '2137': 'Nordea',
    '2138': 'Nordea',
    '2139': 'Nordea',
    '2140': 'Nordea',
    '2141': 'Nordea',
    '2142': 'Nordea',
    '2143': 'Nordea',
    '2144': 'Nordea',
    '2145': 'Nordea',
    '2147': 'Nordea',
    '2148': 'Nordea',
    '2149': 'Nordea',
    '2150': 'Nordea',
    '2152': 'Nordea',
    '2153': 'Nordea',
    '2155': 'Nordea',
    '2156': 'Nordea',
    '2157': 'Nordea',
    '2159': 'Nordea',
    '2161': 'Nordea',
    '2162': 'Nordea',
    '2164': 'Nordea',
    '2165': 'Nordea',
    '2166': 'Nordea',
    '2168': 'Nordea',
    '2170': 'Nordea',
    '2172': 'Nordea',
    '2173': 'Nordea',
    '2174': 'Nordea',
    '2177': 'Nordea',
    '2178': 'Nordea',
    '2181': 'Nordea',
    '2182': 'Nordea',
    '2183': 'Nordea',
    '2185': 'Nordea',
    '2186': 'Nordea',
    '2187': 'Nordea',
    '2189': 'Nordea',
    '2190': 'Nordea',
    '2191': 'Nordea',
    '2193': 'Nordea',
    '2194': 'Nordea',
    '2195': 'Nordea',
    '2196': 'Nordea',
    '2197': 'Nordea',
    '2198': 'Nordea',
    '2199': 'Nordea',
    '2201': 'Nordea',
    '2202': 'Nordea',
    '2203': 'Nordea',
    '2204': 'Nordea',
    '2205': 'Nordea',
    '2206': 'Nordea',
    '2207': 'Nordea',
    '2208': 'Nordea',
    '2209': 'Nordea',
    '2210': 'Nordea',
    '2211': 'Nordea',
    '2212': 'Nordea',
    '2213': 'Nordea',
    '2214': 'Nordea',
    '2215': 'Nordea',
    '2216': 'Nordea',
    '2217': 'Nordea',
    '2218': 'Nordea',
    '2219': 'Nordea',
    '2220': 'Nordea',
    '2222': 'Nordea',
    '2223': 'Nordea',
    '2224': 'Nordea',
    '2226': 'Nordea',
    '2228': 'Nordea',
    '2229': 'Nordea',
    '2230': 'Nordea',
    '2232': 'Nordea',
    '2233': 'Nordea',
    '2235': 'Nordea',
    '2236': 'Nordea',
    '2237': 'Nordea',
    '2239': 'Nordea',
    '2240': 'Nordea',
    '2241': 'Nordea',
    '2242': 'Nordea',
    '2243': 'Nordea',
    '2245': 'Nordea',
    '2246': 'Nordea',
    '2247': 'Nordea',
    '2251': 'Nordea',
    '2252': 'Nordea',
    '2253': 'Nordea',
    '2254': 'Nordea',
    '2255': 'Nordea',
    '2256': 'Nordea',
    '2257': 'Nordea',
    '2259': 'Nordea',
    '2260': 'Nordea',
    '2261': 'Nordea',
    '2262': 'Nordea',
    '2263': 'Nordea',
    '2264': 'Nordea',
    '2265': 'Nordea',
    '2266': 'Nordea',
    '2267': 'Nordea',
    '2268': 'Nordea',
    '2269': 'Nordea',
    '2270': 'Nordea',
    '2271': 'Nordea',
    '2272': 'Nordea',
    '2273': 'Nordea',
    '2274': 'Nordea',
    '2275': 'Nordea',
    '2276': 'Nordea',
    '2277': 'Nordea',
    '2278': 'Nordea',
    '2279': 'Nordea',
    '2280': 'Nordea',
    '2281': 'Nordea',
    '2282': 'Nordea',
    '2283': 'Nordea',
    '2284': 'Nordea',
    '2285': 'Nordea',
    '2286': 'Nordea',
    '2287': 'Nordea',
    '2288': 'Nordea',
    '2289': 'Nordea',
    '2290': 'Nordea',
    '2291': 'Nordea',
    '2292': 'Nordea',
    '2293': 'Nordea',
    '2294': 'Nordea',
    '2295': 'Nordea',
    '2296': 'Nordea',
    '2300': 'Nordea',
    '2301': 'Nordea',
    '2302': 'Nordea',
    '2305': 'Nordea',
    '2306': 'Nordea',
    '2307': 'Nordea',
    '2308': 'Nordea',
    '2310': 'Nordea',
    '2311': 'Nordea',
    '2313': 'Nordea',
    '2314': 'Nordea',
    '2315': 'Nordea',
    '2316': 'Nordea',
    '2317': 'Nordea',
    '2318': 'Nordea',
    '2320': 'Nordea',
    '2321': 'Nordea',
    '2322': 'Nordea',
    '2323': 'Nordea',
    '2324': 'Nordea',
    '2325': 'Nordea',
    '2330': 'Nordea',
    '2331': 'Nordea',
    '2332': 'Nordea',
    '2334': 'Nordea',
    '2335': 'Nordea',
    '2336': 'Nordea',
    '2340': 'Nordea',
    '2341': 'Nordea',
    '2342': 'Nordea',
    '2343': 'Nordea',
    '2344': 'Nordea',
    '2346': 'Nordea',
    '2347': 'Nordea',
    '2348': 'Nordea',
    '2350': 'Nordea',
    '2351': 'Nordea',
    '2352': 'Nordea',
    '2356': 'Nordea',
    '2358': 'Nordea',
    '2360': 'Nordea',
    '2361': 'Nordea',
    '2362': 'Nordea',
    '2363': 'Nordea',
    '2364': 'Nordea',
    '2366': 'Nordea',
    '2370': 'Nordea',
    '2371': 'Nordea',
    '2373': 'Nordea',
    '2374': 'Nordea',
    '2375': 'Nordea',
    '2376': 'Nordea',
    '2377': 'Nordea',
    '2378': 'Nordea',
    '2379': 'Nordea',
    '2380': 'Nordea',
    '2381': 'Nordea',
    '2382': 'Nordea',
    '2383': 'Nordea',
    '2384': 'Nordea',
    '2390': 'Nordea',
    '2392': 'Nordea',
    '2393': 'Nordea',
    '2400': 'Nordea',
    '2401': 'Nordea',
    '2402': 'Nordea',
    '2403': 'Nordea',
    '2404': 'Nordea',
    '2405': 'Nordea',
    '2406': 'Nordea',
    '2407': 'Nordea',
    '2408': 'Nordea',
    '2409': 'Nordea',
    '2410': 'Nordea',
    '2411': 'Nordea',
    '2412': 'Nordea',
    '2413': 'Nordea',
    '2414': 'Nordea',
    '2415': 'Nordea',
    '2416': 'Nordea',
    '2417': 'Nordea',
    '2418': 'Nordea',
    '2419': 'Nordea',
    '2420': 'Nordea',
    '2421': 'Nordea',
    '2423': 'Nordea',
    '2424': 'Nordea',
    '2425': 'Nordea',
    '2426': 'Nordea',
    '2427': 'Nordea',
    '2428': 'Nordea',
    '2429': 'Nordea',
    '2430': 'Nordea',
    '2431': 'Nordea',
    '2432': 'Nordea',
    '2433': 'Nordea',
    '2434': 'Nordea',
    '2435': 'Nordea',
    '2436': 'Nordea',
    '2437': 'Nordea',
    '2438': 'Nordea',
    '2440': 'Nordea',
    '2441': 'Nordea',
    '2442': 'Nordea',
    '2443': 'Nordea',
    '2444': 'Nordea',
    '2445': 'Nordea',
    '2446': 'Nordea',
    '2447': 'Nordea',
    '2448': 'Nordea',
    '2449': 'Nordea',
    '2450': 'Nordea',
    '2451': 'Nordea',
    '2452': 'Nordea',
    '2453': 'Nordea',
    '2454': 'Nordea',
    '2455': 'Nordea',
    '2456': 'Nordea',
    '2457': 'Nordea',
    '2459': 'Nordea',
    '2460': 'Nordea',
    '2462': 'Nordea',
    '2463': 'Nordea',
    '2464': 'Nordea',
    '2465': 'Nordea',
    '2466': 'Nordea',
    '2468': 'Nordea',
    '2469': 'Nordea',
    '2470': 'Nordea',
    '2471': 'Nordea',
    '2472': 'Nordea',
    '2473': 'Nordea',
    '2474': 'Nordea',
    '2475': 'Nordea',
    '2476': 'Nordea',
    '2480': 'Nordea',
    '2481': 'Nordea',
    '2482': 'Nordea',
    '2483': 'Nordea',
    '2484': 'Nordea',
    '2485': 'Nordea',
    '2490': 'Nordea',
    '2491': 'Nordea',
    '2492': 'Nordea',
    '2495': 'Nordea',
    '2500': 'Nordea',
    '2501': 'Nordea',
    '2502': 'Nordea',
    '2504': 'Nordea',
    '2510': 'Nordea',
    '2520': 'Nordea',
    '2521': 'Nordea',
    '2522': 'Nordea',
    '2523': 'Nordea',
    '2524': 'Nordea',
    '2530': 'Nordea',
    '2540': 'Nordea',
    '2541': 'Nordea',
    '2543': 'Nordea',
    '2550': 'Nordea',
    '2560': 'Nordea',
    '2561': 'Nordea',
    '2562': 'Nordea',
    '2570': 'Nordea',
    '2571': 'Nordea',
    '2572': 'Nordea',
    '2580': 'Nordea',
    '2589': 'Nordea',
    '2590': 'Nordea',
    '2591': 'Nordea',
    '2592': 'Nordea',
    '2593': 'Nordea',
    '2594': 'Nordea',
    '2595': 'Nordea',
    '2596': 'Nordea',
    '2597': 'Nordea',
    '2598': 'Nordea',
    '2599': 'Nordea',
    '2600': 'Nordea',
    '2601': 'Nordea',
    '2603': 'Nordea',
    '2610': 'Nordea',
    '2620': 'Nordea',
    '2630': 'Nordea',
    '2640': 'Nordea',
    '2641': 'Nordea',
    '2643': 'Nordea',
    '2644': 'Nordea',
    '2645': 'Nordea',
    '2646': 'Nordea',
    '2647': 'Nordea',
    '2648': 'Nordea',
    '2649': 'Nordea',
    '2650': 'Nordea',
    '2651': 'Nordea',
    '2652': 'Nordea',
    '2653': 'Nordea',
    '2654': 'Nordea',
    '2655': 'Nordea',
    '2656': 'Nordea',
    '2657': 'Nordea',
    '2658': 'Nordea',
    '2659': 'Nordea',
    '2660': 'Nordea',
    '2661': 'Nordea',
    '2662': 'Nordea',
    '2663': 'Nordea',
    '2664': 'Nordea',
    '2665': 'Nordea',
    '2666': 'Nordea',
    '2667': 'Nordea',
    '2668': 'Nordea',
    '2669': 'Nordea',
    '2670': 'Nordea',
    '2671': 'Nordea',
    '2672': 'Nordea',
    '2673': 'Nordea',
    '2674': 'Nordea',
    '2675': 'Nordea',
    '2676': 'Nordea',
    '2680': 'Nordea',
    '2690': 'Nordea',
    '2700': 'Nordea',
    '2701': 'Nordea',
    '2702': 'Nordea',
    '2703': 'Nordea',
    '2704': 'Nordea',
    '2706': 'Nordea',
    '2707': 'Nordea',
    '2709': 'Nordea',
    '2712': 'Nordea',
    '2720': 'Nordea',
    '2730': 'Nordea',
    '2740': 'Nordea',
    '2750': 'Nordea',
    '2752': 'Nordea',
    '2760': 'Nordea',
    '2761': 'Nordea',
    '2762': 'Nordea',
    '2764': 'Nordea',
    '2765': 'Nordea',
    '2766': 'Nordea',
    '2767': 'Nordea',
    '2768': 'Nordea',
    '2769': 'Nordea',
    '2770': 'Nordea',
    '2772': 'Nordea',
    '2775': 'Nordea',
    '2776': 'Nordea',
    '2777': 'Nordea',
    '2778': 'Nordea',
    '2779': 'Nordea',
    '2780': 'Nordea',
    '2781': 'Nordea',
    '2783': 'Nordea',
    '2784': 'Nordea',
    '2785': 'Nordea',
    '2786': 'Nordea',
    '2787': 'Nordea',
    '2788': 'Nordea',
    '2805': 'Nordea',
    '2806': 'Nordea',
    '2807': 'Nordea',
    '2810': 'Nordea',
    '2815': 'Nordea',
    '2816': 'Nordea',
    '2820': 'Nordea',
    '2821': 'Nordea',
    '2822': 'Nordea',
    '2825': 'Nordea',
    '2830': 'Nordea',
    '2831': 'Nordea',
    '2835': 'Nordea',
    '2840': 'Nordea',
    '2841': 'Nordea',
    '2845': 'Nordea',
    '2850': 'Nordea',
    '2851': 'Nordea',
    '2852': 'Nordea',
    '2853': 'Nordea',
    '2884': 'Nordea',
    '2885': 'Nordea',
    '2900': 'Nordea',
    '2901': 'Nordea',
    '2902': 'Nordea',
    '2903': 'Nordea',
    '2904': 'Nordea',
    '2905': 'Nordea',
    '2906': 'Nordea',
    '2907': 'Nordea',
    '2908': 'Nordea',
    '2909': 'Nordea',
    '2913': 'Nordea',
    '2915': 'Nordea',
    '2916': 'Nordea',
    '2917': 'Nordea',
    '2918': 'Nordea',
    '2919': 'Nordea',
    '2920': 'Nordea',
    '2922': 'Nordea',
    '2924': 'Nordea',
    '2925': 'Nordea',
    '2926': 'Nordea',
    '2927': 'Nordea',
    '2928': 'Nordea',
    '2930': 'Nordea',
    '2950': 'Nordea',
    '2955': 'Nordea',
    '2957': 'Nordea',
    '2968': 'Nordea',
    '2971': 'Nordea',
    '2972': 'Nordea',
    '2973': 'Nordea',
    '2974': 'Nordea',
    '2975': 'Nordea',
    '2976': 'Nordea',
    '2977': 'Nordea',
    '2978': 'Nordea',
    '2979': 'Nordea',
    '2980': 'Nordea',
    '2983': 'Nordea',
    '2984': 'Nordea',
    '2985': 'Nordea',
    '2986': 'Nordea',
    '2987': 'Nordea',
    '2988': 'Nordea',
    '2989': 'Nordea',
    '2991': 'Nordea',
    '2992': 'Nordea',
    '2996': 'Nordea',
    '3000': 'Danske Bank',
    '3001': 'Danske Bank',
    '3002': 'Danske Bank',
    '3003': 'Danske Bank',
    '3008': 'Danske Bank',
    '3010': 'Danske Bank',
    '3011': 'Danske Bank',
    '3012': 'Danske Bank',
    '3013': 'Danske Bank',
    '3014': 'Danske Bank',
    '3015': 'Danske Bank',
    '3020': 'Danske Bank',
    '3022': 'Danske Bank',
    '3024': 'Danske Bank',
    '3028': 'Danske Bank',
    '3042': 'Danske Bank',
    '3043': 'Danske Bank',
    '3054': 'Danske Bank',
    '3057': 'Danske Bank',
    '3058': 'Danske Bank',
    '3063': 'Danske Bank',
    '3066': 'Danske Bank',
    '3067': 'Danske Bank',
    '3068': 'Danske Bank',
    '3071': 'Danske Bank',
    '3073': 'Danske Bank',
    '3077': 'Danske Bank',
    '3091': 'Danske Bank',
    '3098': 'Danske Bank',
    '3100': 'Danske Bank',
    '3103': 'Danske Bank',
    '3106': 'Danske Bank',
    '3107': 'Danske Bank',
    '3109': 'Danske Bank',
    '3110': 'Danske Bank',
    '3112': 'Danske Bank',
    '3113': 'Danske Bank',
    '3114': 'Danske Bank',
    '3115': 'Danske Bank',
    '3117': 'Danske Bank',
    '3118': 'Danske Bank',
    '3121': 'Danske Bank',
    '3123': 'Danske Bank',
    '3124': 'Danske Bank',
    '3128': 'Danske Bank',
    '3129': 'Danske Bank',
    '3130': 'Danske Bank',
    '3134': 'Danske Bank',
    '3137': 'Danske Bank',
    '3138': 'Danske Bank',
    '3139': 'Danske Bank',
    '3140': 'Danske Bank',
    '3141': 'Danske Bank',
    '3143': 'Danske Bank',
    '3144': 'Danske Bank',
    '3146': 'Danske Bank',
    '3148': 'Danske Bank',
    '3149': 'Danske Bank',
    '3152': 'Danske Bank',
    '3154': 'Danske Bank',
    '3155': 'Danske Bank',
    '3156': 'Danske Bank',
    '3159': 'Danske Bank',
    '3161': 'Danske Bank',
    '3162': 'Danske Bank',
    '3163': 'Danske Bank',
    '3164': 'Danske Bank',
    '3167': 'Danske Bank',
    '3168': 'Danske Bank',
    '3169': 'Danske Bank',
    '3170': 'Danske Bank',
    '3171': 'Danske Bank',
    '3172': 'Danske Bank',
    '3173': 'Danske Bank',
    '3174': 'Danske Bank',
    '3175': 'Danske Bank',
    '3177': 'Danske Bank',
    '3178': 'Danske Bank',
    '3183': 'Danske Bank',
    '3185': 'Danske Bank',
    '3186': 'Danske Bank',
    '3188': 'Danske Bank',
    '3191': 'Danske Bank',
    '3193': 'Danske Bank',
    '3194': 'Danske Bank',
    '3198': 'Danske Bank',
    '3199': 'Danske Bank',
    '3201': 'Danske Bank',
    '3203': 'Danske Bank',
    '3204': 'Danske Bank',
    '3205': 'Danske Bank',
    '3206': 'Danske Bank',
    '3208': 'Danske Bank',
    '3211': 'Danske Bank',
    '3212': 'Danske Bank',
    '3215': 'Danske Bank',
    '3216': 'Danske Bank',
    '3217': 'Danske Bank',
    '3218': 'Danske Bank',
    '3219': 'Danske Bank',
    '3221': 'Danske Bank',
    '3222': 'Danske Bank',
    '3223': 'Danske Bank',
    '3224': 'Danske Bank',
    '3225': 'Danske Bank',
    '3226': 'Danske Bank',
    '3227': 'Danske Bank',
    '3229': 'Danske Bank',
    '3230': 'Danske Bank',
    '3231': 'Danske Bank',
    '3232': 'Danske Bank',
    '3234': 'Danske Bank',
    '3238': 'Danske Bank',
    '3241': 'Danske Bank',
    '3243': 'Danske Bank',
    '3244': 'Danske Bank',
    '3251': 'Danske Bank',
    '3256': 'Danske Bank',
    '3259': 'Danske Bank',
    '3262': 'Danske Bank',
    '3263': 'Danske Bank',
    '3264': 'Danske Bank',
    '3265': 'Danske Bank',
    '3266': 'Danske Bank',
    '3269': 'Danske Bank',
    '3271': 'Danske Bank',
    '3282': 'Danske Bank',
    '3283': 'Danske Bank',
    '3285': 'Danske Bank',
    '3287': 'Danske Bank',
    '3288': 'Danske Bank',
    '3291': 'Danske Bank',
    '3296': 'Danske Bank',
    '3306': 'Danske Bank',
    '3307': 'Danske Bank',
    '3312': 'Danske Bank',
    '3315': 'Danske Bank',
    '3316': 'Danske Bank',
    '3318': 'Danske Bank',
    '3319': 'Danske Bank',
    '3321': 'Danske Bank',
    '3322': 'Danske Bank',
    '3324': 'Danske Bank',
    '3325': 'Danske Bank',
    '3326': 'Danske Bank',
    '3333': 'Danske Bank',
    '3334': 'Danske Bank',
    '3336': 'Danske Bank',
    '3338': 'Danske Bank',
    '3341': 'Danske Bank',
    '3344': 'Danske Bank',
    '3345': 'Danske Bank',
    '3346': 'Danske Bank',
    '3347': 'Danske Bank',
    '3348': 'Danske Bank',
    '3349': 'Danske Bank',
    '3350': 'Danske Bank',
    '3357': 'Danske Bank',
    '3359': 'Danske Bank',
    '3361': 'Danske Bank',
    '3386': 'Danske Bank',
    '3387': 'Danske Bank',
    '3390': 'Danske Bank',
    '3391': 'Danske Bank',
    '3395': 'Danske Bank',
    '3401': 'Danske Bank',
    '3404': 'Danske Bank',
    '3405': 'Danske Bank',
    '3406': 'Danske Bank',
    '3408': 'Danske Bank',
    '3409': 'Danske Bank',
    '3411': 'Danske Bank',
    '3412': 'Danske Bank',
    '3415': 'Danske Bank',
    '3416': 'Danske Bank',
    '3420': 'Danske Bank',
    '3421': 'Danske Bank',
    '3426': 'Danske Bank',
    '3427': 'Danske Bank',
    '3428': 'Danske Bank',
    '3429': 'Danske Bank',
    '3430': 'Danske Bank',
    '3431': 'Danske Bank',
    '3433': 'Danske Bank',
    '3434': 'Danske Bank',
    '3437': 'Danske Bank',
    '3439': 'Danske Bank',
    '3440': 'Danske Bank',
    '3443': 'Danske Bank',
    '3445': 'Danske Bank',
    '3448': 'Danske Bank',
    '3449': 'Danske Bank',
    '3453': 'Danske Bank',
    '3457': 'Danske Bank',
    '3462': 'Danske Bank',
    '3463': 'Danske Bank',
    '3467': 'Danske Bank',
    '3470': 'Danske Bank',
    '3479': 'Danske Bank',
    '3480': 'Danske Bank',
    '3482': 'Danske Bank',
    '3487': 'Danske Bank',
    '3489': 'Danske Bank',
    '3490': 'Danske Bank',
    '3506': 'Danske Bank',
    '3507': 'Danske Bank',
    '3508': 'Danske Bank',
    '3509': 'Danske Bank',
    '3511': 'Danske Bank',
    '3512': 'Danske Bank',
    '3515': 'Danske Bank',
    '3517': 'Danske Bank',
    '3523': 'Danske Bank',
    '3525': 'Danske Bank',
    '3530': 'Danske Bank',
    '3531': 'Danske Bank',
    '3534': 'Danske Bank',
    '3537': 'Danske Bank',
    '3543': 'Danske Bank',
    '3544': 'Danske Bank',
    '3545': 'Danske Bank',
    '3555': 'Danske Bank',
    '3556': 'Danske Bank',
    '3562': 'Danske Bank',
    '3565': 'Danske Bank',
    '3566': 'Danske Bank',
    '3567': 'Danske Bank',
    '3568': 'Danske Bank',
    '3569': 'Danske Bank',
    '3572': 'Danske Bank',
    '3573': 'Danske Bank',
    '3574': 'Danske Bank',
    '3575': 'Danske Bank',
    '3577': 'Danske Bank',
    '3578': 'Danske Bank',
    '3586': 'Danske Bank',
    '3588': 'Danske Bank',
    '3590': 'Danske Bank',
    '3591': 'Danske Bank',
    '3596': 'Danske Bank',
    '3597': 'Danske Bank',
    '3600': 'Danske Bank',
    '3603': 'Danske Bank',
    '3604': 'Danske Bank',
    '3606': 'Danske Bank',
    '3609': 'Danske Bank',
    '3610': 'Danske Bank',
    '3611': 'Danske Bank',
    '3612': 'Danske Bank',
    '3613': 'Danske Bank',
    '3614': 'Danske Bank',
    '3616': 'Danske Bank',
    '3618': 'Danske Bank',
    '3619': 'Danske Bank',
    '3627': 'Danske Bank',
    '3628': 'Danske Bank',
    '3629': 'Danske Bank',
    '3630': 'Danske Bank',
    '3631': 'Danske Bank',
    '3632': 'Danske Bank',
    '3633': 'Danske Bank',
    '3635': 'Danske Bank',
    '3636': 'Danske Bank',
    '3638': 'Danske Bank',
    '3639': 'Danske Bank',
    '3640': 'Danske Bank',
    '3642': 'Danske Bank',
    '3643': 'Danske Bank',
    '3645': 'Danske Bank',
    '3647': 'Danske Bank',
    '3648': 'Danske Bank',
    '3649': 'Danske Bank',
    '3651': 'Danske Bank',
    '3652': 'Danske Bank',
    '3654': 'Danske Bank',
    '3655': 'Danske Bank',
    '3656': 'Danske Bank',
    '3657': 'Danske Bank',
    '3661': 'Danske Bank',
    '3667': 'Danske Bank',
    '3668': 'Danske Bank',
    '3671': 'Danske Bank',
    '3672': 'Danske Bank',
    '3673': 'Danske Bank',
    '3674': 'Danske Bank',
    '3675': 'Danske Bank',
    '3678': 'Danske Bank',
    '3679': 'Danske Bank',
    '3683': 'Danske Bank',
    '3684': 'Danske Bank',
    '3685': 'Danske Bank',
    '3686': 'Danske Bank',
    '3688': 'Danske Bank',
    '3695': 'Danske Bank',
    '3696': 'Danske Bank',
    '3697': 'Danske Bank',
    '3698': 'Danske Bank',
    '3701': 'Danske Bank',
    '3702': 'Danske Bank',
    '3703': 'Danske Bank',
    '3705': 'Danske Bank',
    '3706': 'Danske Bank',
    '3708': 'Danske Bank',
    '3710': 'Danske Bank',
    '3711': 'Danske Bank',
    '3714': 'Danske Bank',
    '3724': 'Danske Bank',
    '3730': 'Danske Bank',
    '3733': 'Danske Bank',
    '3734': 'Danske Bank',
    '3735': 'Danske Bank',
    '3737': 'Danske Bank',
    '3738': 'Danske Bank',
    '3740': 'Danske Bank',
    '3741': 'Danske Bank',
    '3742': 'Danske Bank',
    '3743': 'Danske Bank',
    '3747': 'Danske Bank',
    '3748': 'Danske Bank',
    '3750': 'Danske Bank',
    '3767': 'Danske Bank',
    '3775': 'Danske Bank',
    '3776': 'Danske Bank',
    '3777': 'Danske Bank',
    '3778': 'Danske Bank',
    '3779': 'Danske Bank',
    '3783': 'Danske Bank',
    '3784': 'Danske Bank',
    '3785': 'Danske Bank',
    '3786': 'Danske Bank',
    '3787': 'Danske Bank',
    '3788': 'Danske Bank',
    '3789': 'Danske Bank',
    '3809': 'Danske Bank',
    '3824': 'Danske Bank',
    '3825': 'Danske Bank',
    '3827': 'Danske Bank',
    '3828': 'Danske Bank',
    '3829': 'Danske Bank',
    '3830': 'Danske Bank',
    '3837': 'Danske Bank',
    '3838': 'Danske Bank',
    '3840': 'Danske Bank',
    '3845': 'Danske Bank',
    '3846': 'Danske Bank',
    '3858': 'Danske Bank',
    '3860': 'Danske Bank',
    '3861': 'Danske Bank',
    '3862': 'Danske Bank',
    '3864': 'Danske Bank',
    '3868': 'Danske Bank',
    '3873': 'Danske Bank',
    '3874': 'Danske Bank',
    '3880': 'Danske Bank',
    '3881': 'Danske Bank',
    '3882': 'Danske Bank',
    '3883': 'Danske Bank',
    '3884': 'Danske Bank',
    '3885': 'Danske Bank',
    '3886': 'Danske Bank',
    '3887': 'Danske Bank',
    '3896': 'Danske Bank',
    '3901': 'Danske Bank',
    '3903': 'Danske Bank',
    '3913': 'Danske Bank',
    '3914': 'Danske Bank',
    '3920': 'Danske Bank',
    '3921': 'Danske Bank',
    '3922': 'Danske Bank',
    '3924': 'Danske Bank',
    '3925': 'Danske Bank',
    '3928': 'Danske Bank',
    '3930': 'Danske Bank',
    '3931': 'Danske Bank',
    '3936': 'Danske Bank',
    '3939': 'Danske Bank',
    '3940': 'Danske Bank',
    '3941': 'Danske Bank',
    '3943': 'Danske Bank',
    '3945': 'Danske Bank',
    '3946': 'Danske Bank',
    '3947': 'Danske Bank',
    '3948': 'Danske Bank',
    '3950': 'Danske Bank',
    '3952': 'Danske Bank',
    '3954': 'Danske Bank',
    '3956': 'Danske Bank',
    '3958': 'Danske Bank',
    '3970': 'Danske Bank',
    '3981': 'Danske Bank',
    '3985': 'Danske Bank',
    '3991': 'Danske Bank',
    '3993': 'Danske Bank',
    '3996': 'Danske Bank',
    '3999': 'Danske Bank',
    '4000': 'Danske Bank',
    '4001': 'Danske Bank',
    '4002': 'Danske Bank',
    '4003': 'Danske Bank',
    '4014': 'Danske Bank',
    '4015': 'Danske Bank',
    '4018': 'Danske Bank',
    '4020': 'Danske Bank',
    '4023': 'Danske Bank',
    '4024': 'Danske Bank',
    '4025': 'Danske Bank',
    '4027': 'Danske Bank',
    '4028': 'Danske Bank',
    '4029': 'Danske Bank',
    '4030': 'Danske Bank',
    '4031': 'Danske Bank',
    '4032': 'Danske Bank',
    '4033': 'Danske Bank',
    '4037': 'Danske Bank',
    '4038': 'Danske Bank',
    '4039': 'Danske Bank',
    '4040': 'Danske Bank',
    '4041': 'Danske Bank',
    '4045': 'Danske Bank',
    '4046': 'Danske Bank',
    '4047': 'Danske Bank',
    '4048': 'Danske Bank',
    '4049': 'Danske Bank',
    '4050': 'Danske Bank',
    '4051': 'Danske Bank',
    '4052': 'Danske Bank',
    '4053': 'Danske Bank',
    '4054': 'Danske Bank',
    '4057': 'Danske Bank',
    '4061': 'Danske Bank',
    '4064': 'Danske Bank',
    '4065': 'Danske Bank',
    '4066': 'Danske Bank',
    '4067': 'Danske Bank',
    '4070': 'Danske Bank',
    '4072': 'Danske Bank',
    '4073': 'Danske Bank',
    '4076': 'Danske Bank',
    '4083': 'Danske Bank',
    '4085': 'Danske Bank',
    '4089': 'Danske Bank',
    '4090': 'Danske Bank',
    '4092': 'Danske Bank',
    '4095': 'Danske Bank',
    '4099': 'Danske Bank',
    '4120': 'Danske Bank',
    '4130': 'Danske Bank',
    '4133': 'Danske Bank',
    '4160': 'Danske Bank',
    '4180': 'Danske Bank',
    '4183': 'Danske Bank',
    '4188': 'Danske Bank',
    '4189': 'Danske Bank',
    '4190': 'Danske Bank',
    '4200': 'Danske Bank',
    '4201': 'Danske Bank',
    '4205': 'Danske Bank',
    '4230': 'Danske Bank',
    '4250': 'Danske Bank',
    '4260': 'Danske Bank',
    '4263': 'Danske Bank',
    '4278': 'Danske Bank',
    '4279': 'Danske Bank',
    '4280': 'Danske Bank',
    '4282': 'Danske Bank',
    '4284': 'Danske Bank',
    '4287': 'Danske Bank',
    '4300': 'Danske Bank',
    '4309': 'Danske Bank',
    '4310': 'Danske Bank',
    '4312': 'Danske Bank',
    '4314': 'Danske Bank',
    '4315': 'Danske Bank',
    '4316': 'Danske Bank',
    '4317': 'Danske Bank',
    '4319': 'Danske Bank',
    '4330': 'Danske Bank',
    '4336': 'Danske Bank',
    '4343': 'Danske Bank',
    '4348': 'Danske Bank',
    '4356': 'Danske Bank',
    '4363': 'Danske Bank',
    '4366': 'Danske Bank',
    '4368': 'Danske Bank',
    '4380': 'Danske Bank',
    '4383': 'Danske Bank',
    '4386': 'Danske Bank',
    '4387': 'Danske Bank',
    '4394': 'Danske Bank',
    '4396': 'Danske Bank',
    '4398': 'Danske Bank',
    '4400': 'Danske Bank',
    '4401': 'Danske Bank',
    '4403': 'Danske Bank',
    '4406': 'Danske Bank',
    '4420': 'Danske Bank',
    '4424': 'Danske Bank',
    '4425': 'Danske Bank',
    '4426': 'Danske Bank',
    '4434': 'Danske Bank',
    '4440': 'Danske Bank',
    '4444': 'Danske Bank',
    '4447': 'Danske Bank',
    '4448': 'Danske Bank',
    '4450': 'Danske Bank',
    '4451': 'Danske Bank',
    '4453': 'Danske Bank',
    '4460': 'Danske Bank',
    '4467': 'Danske Bank',
    '4480': 'Danske Bank',
    '4485': 'Danske Bank',
    '4490': 'Danske Bank',
    '4496': 'Danske Bank',
    '4498': 'Danske Bank',
    '4511': 'Danske Bank',
    '4515': 'Danske Bank',
    '4530': 'Danske Bank',
    '4540': 'Danske Bank',
    '4560': 'Danske Bank',
    '4580': 'Danske Bank',
    '4582': 'Danske Bank',
    '4584': 'Danske Bank',
    '4585': 'Danske Bank',
    '4587': 'Danske Bank',
    '4592': 'Danske Bank',
    '4595': 'Danske Bank',
    '4596': 'Danske Bank',
    '4597': 'Danske Bank',
    '4598': 'Danske Bank',
    '4605': 'Danske Bank',
    '4606': 'Danske Bank',
    '4610': 'Danske Bank',
    '4611': 'Danske Bank',
    '4619': 'Danske Bank',
    '4620': 'Danske Bank',
    '4625': 'Danske Bank',
    '4629': 'Danske Bank',
    '4630': 'Danske Bank',
    '4633': 'Danske Bank',
    '4634': 'Danske Bank',
    '4640': 'Danske Bank',
    '4644': 'Danske Bank',
    '4645': 'Danske Bank',
    '4649': 'Danske Bank',
    '4650': 'Danske Bank',
    '4652': 'Danske Bank',
    '4657': 'Danske Bank',
    '4660': 'Danske Bank',
    '4662': 'Danske Bank',
    '4663': 'Danske Bank',
    '4665': 'Danske Bank',
    '4669': 'Danske Bank',
    '4671': 'Danske Bank',
    '4672': 'Danske Bank',
    '4676': 'Danske Bank',
    '4681': 'Danske Bank',
    '4690': 'Danske Bank',
    '4691': 'Danske Bank',
    '4692': 'Danske Bank',
    '4695': 'Danske Bank',
    '4701': 'Danske Bank',
    '4703': 'Danske Bank',
    '4710': 'Danske Bank',
    '4713': 'Danske Bank',
    '4716': 'Danske Bank',
    '4720': 'Danske Bank',
    '4727': 'Danske Bank',
    '4728': 'Danske Bank',
    '4731': 'Danske Bank',
    '4733': 'Danske Bank',
    '4735': 'Danske Bank',
    '4736': 'Danske Bank',
    '4738': 'Danske Bank',
    '4739': 'Danske Bank',
    '4745': 'Danske Bank',
    '4747': 'Danske Bank',
    '4754': 'Danske Bank',
    '4756': 'Danske Bank',
    '4757': 'Danske Bank',
    '4759': 'Danske Bank',
    '4760': 'Danske Bank',
    '4761': 'Danske Bank',
    '4762': 'Danske Bank',
    '4763': 'Danske Bank',
    '4770': 'Danske Bank',
    '4772': 'Danske Bank',
    '4779': 'Danske Bank',
    '4780': 'Danske Bank',
    '4782': 'Danske Bank',
    '4784': 'Danske Bank',
    '4791': 'Danske Bank',
    '4799': 'Danske Bank',
    '4808': 'Danske Bank',
    '4814': 'Danske Bank',
    '4815': 'Danske Bank',
    '4817': 'Danske Bank',
    '4818': 'Danske Bank',
    '4820': 'Danske Bank',
    '4836': 'Danske Bank',
    '4841': 'Danske Bank',
    '4842': 'Danske Bank',
    '4845': 'Danske Bank',
    '4860': 'Danske Bank',
    '4865': 'Danske Bank',
    '4866': 'Danske Bank',
    '4868': 'Danske Bank',
    '4875': 'Danske Bank',
    '4880': 'Danske Bank',
    '4897': 'Danske Bank',
    '4899': 'Danske Bank',
    '4900': 'Danske Bank',
    '4904': 'Danske Bank',
    '4905': 'Danske Bank',
    '4907': 'Danske Bank',
    '4908': 'Danske Bank',
    '4912': 'Danske Bank',
    '4913': 'Danske Bank',
    '4915': 'Danske Bank',
    '4916': 'Danske Bank',
    '4917': 'Danske Bank',
    '4918': 'Danske Bank',
    '4920': 'Danske Bank',
    '4921': 'Danske Bank',
    '4922': 'Danske Bank',
    '4923': 'Danske Bank',
    '4925': 'Danske Bank',
    '4927': 'Danske Bank',
    '4928': 'Danske Bank',
    '4929': 'Danske Bank',
    '4930': 'Danske Bank',
    '4932': 'Danske Bank',
    '4936': 'Danske Bank',
    '4940': 'Danske Bank',
    '4945': 'Danske Bank',
    '4951': 'Danske Bank',
    '4955': 'Danske Bank',
    '4956': 'Danske Bank',
    '4957': 'Nordania Leasing Bank',
    '4971': 'Danske Bank',
    '5002': 'Jyske Bank',
    '5005': 'Jyske Bank',
    '5006': 'Jyske Bank',
    '5007': 'Jyske Bank',
    '5009': 'Jyske Bank',
    '5010': 'Jyske Bank',
    '5011': 'Jyske Bank',
    '5012': 'Jyske Bank',
    '5013': 'Jyske Bank',
    '5014': 'Jyske Bank',
    '5015': 'Jyske Bank',
    '5016': 'Jyske Bank',
    '5017': 'Jyske Bank',
    '5018': 'Jyske Bank',
    '5019': 'Jyske Bank',
    '5020': 'Jyske Bank',
    '5021': 'Jyske Bank',
    '5022': 'Jyske Bank',
    '5023': 'Jyske Bank',
    '5024': 'Jyske Bank',
    '5025': 'Jyske Bank',
    '5026': 'Jyske Bank',
    '5027': 'Jyske Bank',
    '5028': 'Jyske Bank',
    '5029': 'Jyske Bank',
    '5030': 'Jyske Bank',
    '5031': 'Jyske Bank',
    '5032': 'Jyske Bank',
    '5033': 'Jyske Bank',
    '5034': 'Jyske Bank',
    '5035': 'Jyske Bank',
    '5036': 'Jyske Bank',
    '5037': 'Jyske Bank',
    '5038': 'Jyske Bank',
    '5039': 'Jyske Bank',
    '5040': 'Jyske Bank',
    '5041': 'Jyske Bank',
    '5042': 'Jyske Bank',
    '5043': 'Jyske Bank',
    '5044': 'Jyske Bank',
    '5045': 'Jyske Bank',
    '5046': 'Jyske Bank',
    '5047': 'Jyske Bank',
    '5050': 'Jyske Bank',
    '5051': 'Jyske Bank',
    '5052': 'Jyske Bank',
    '5053': 'Jyske Bank',
    '5054': 'Jyske Bank',
    '5055': 'Jyske Bank',
    '5056': 'Jyske Bank',
    '5057': 'Jyske Bank',
    '5058': 'Jyske Bank',
    '5059': 'Jyske Bank',
    '5060': 'Jyske Bank',
    '5061': 'Jyske Bank',
    '5062': 'Jyske Bank',
    '5063': 'Jyske Bank',
    '5064': 'Jyske Bank',
    '5065': 'Jyske Bank',
    '5066': 'Jyske Bank',
    '5067': 'Jyske Bank',
    '5068': 'Jyske Bank',
    '5069': 'Jyske Bank',
    '5071': 'Jyske Bank',
    '5072': 'Jyske Bank',
    '5073': 'Jyske Bank',
    '5074': 'Jyske Bank',
    '5075': 'Jyske Bank',
    '5076': 'Jyske Bank',
    '5077': 'Jyske Bank',
    '5078': 'Jyske Bank',
    '5079': 'Jyske Bank',
    '5081': 'Jyske Bank',
    '5084': 'Jyske Bank',
    '5085': 'Jyske Bank',
    '5087': 'Jyske Bank',
    '5090': 'Jyske Bank',
    '5091': 'Jyske Bank',
    '5093': 'Jyske Bank',
    '5095': 'Jyske Bank',
    '5096': 'Jyske Bank',
    '5097': 'Jyske Bank',
    '5098': 'Jyske Bank',
    '5099': 'Jyske Bank',
    '5100': 'Citibank International Plc.',
    '5130': 'HSH Nordbank AG Filial',
    '5140': 'Finansbanken A/S',
    '5152': 'Aice Bank',
    '5190': 'FS Bank',
    '5191': 'FS Bank',
    '5192': 'FS Bank',
    '5195': 'FS Bank',
    '5201': 'FS Bank',
    '5202': 'FS Bank',
    '5203': 'FS Bank',
    '5204': 'FS Bank',
    '5205': 'FS Bank',
    '5206': 'FS Bank',
    '5207': 'FS Bank',
    '5208': 'FS Bank',
    '5209': 'FS Bank',
    '5210': 'FS Bank',
    '5211': 'FS Bank',
    '5212': 'FS Bank',
    '5213': 'FS Bank',
    '5214': 'FS Bank',
    '5215': 'FS Bank',
    '5217': 'FS Bank',
    '5218': 'FS Bank',
    '5220': 'FS Bank',
    '5221': 'FS Bank',
    '5222': 'FS Bank',
    '5223': 'FS Bank',
    '5224': 'FS Bank',
    '5225': 'FS Bank',
    '5226': 'FS Bank',
    '5227': 'FS Bank',
    '5228': 'FS Bank',
    '5229': 'FS Bank',
    '5230': 'FS Bank',
    '5231': 'FS Bank',
    '5252': '',
    '5280': 'Danske Bank',
    '5287': 'Santander Consumer Bank',
    '5290': 'Dnb Bank Asa',
    '5291': 'Sparekassen Sjælland',
    '5292': 'Sparekassen Sjælland',
    '5294': '5294 FOREX Bank A/S, c/o FOREX VALUTAVEKSLING A/S',
    '5295': 'Skandinaviska Enskilda Banken Ab',
    '5301': 'Arbejdernes Landsbank',
    '5302': 'Arbejdernes Landsbank',
    '5303': 'Arbejdernes Landsbank',
    '5304': 'Arbejdernes Landsbank',
    '5305': 'Arbejdernes Landsbank',
    '5306': 'Arbejdernes Landsbank',
    '5308': 'Arbejdernes Landsbank',
    '5310': 'Arbejdernes Landsbank',
    '5311': 'Arbejdernes Landsbank',
    '5312': 'Arbejdernes Landsbank',
    '5318': 'Arbejdernes Landsbank',
    '5319': 'Arbejdernes Landsbank',
    '5320': 'Arbejdernes Landsbank',
    '5321': 'Arbejdernes Landsbank',
    '5322': 'Arbejdernes Landsbank',
    '5323': 'Arbejdernes Landsbank',
    '5324': 'Arbejdernes Landsbank',
    '5325': 'Arbejdernes Landsbank',
    '5326': 'Arbejdernes Landsbank',
    '5327': 'Arbejdernes Landsbank',
    '5328': 'Arbejdernes Landsbank',
    '5329': 'Arbejdernes Landsbank',
    '5330': 'Arbejdernes Landsbank',
    '5331': 'Arbejdernes Landsbank',
    '5332': 'Arbejdernes Landsbank',
    '5333': 'Arbejdernes Landsbank',
    '5336': 'Arbejdernes Landsbank',
    '5337': 'Arbejdernes Landsbank',
    '5338': 'Arbejdernes Landsbank',
    '5339': 'Arbejdernes Landsbank',
    '5341': 'Arbejdernes Landsbank',
    '5342': 'Arbejdernes Landsbank',
    '5343': 'Arbejdernes Landsbank',
    '5344': 'Arbejdernes Landsbank',
    '5345': 'Arbejdernes Landsbank',
    '5346': 'Arbejdernes Landsbank',
    '5347': 'Arbejdernes Landsbank',
    '5348': 'Arbejdernes Landsbank',
    '5349': 'Arbejdernes Landsbank',
    '5350': 'Arbejdernes Landsbank',
    '5351': 'Arbejdernes Landsbank',
    '5352': 'Arbejdernes Landsbank',
    '5353': 'Arbejdernes Landsbank',
    '5354': 'Arbejdernes Landsbank',
    '5355': 'Arbejdernes Landsbank',
    '5356': 'Arbejdernes Landsbank',
    '5357': 'Arbejdernes Landsbank',
    '5358': 'Arbejdernes Landsbank',
    '5359': 'Arbejdernes Landsbank',
    '5360': 'Arbejdernes Landsbank',
    '5361': 'Arbejdernes Landsbank',
    '5362': 'Arbejdernes Landsbank',
    '5363': 'Arbejdernes Landsbank',
    '5364': 'Arbejdernes Landsbank',
    '5365': 'Arbejdernes Landsbank',
    '5366': 'Arbejdernes Landsbank',
    '5367': 'Arbejdernes Landsbank',
    '5368': 'Arbejdernes Landsbank',
    '5370': 'Arbejdernes Landsbank',
    '5371': 'Arbejdernes Landsbank',
    '5372': 'Arbejdernes Landsbank',
    '5373': 'Arbejdernes Landsbank',
    '5375': 'Arbejderes Landsbank',
    '5376': 'Arbejdernes Landsbank',
    '5377': 'Arbejdernes Landsbank',
    '5378': 'Arbejdernes Landsbank',
    '5379': 'Arbejdernes Landsbank',
    '5380': 'Arbejdernes Landsbank',
    '5381': 'Arbejdernes Landsbank',
    '5382': 'Arbejdernes Landsbank',
    '5383': 'Arbejdernes Landsbank',
    '5384': 'Arbejdernes Landsbank',
    '5385': 'Arbejdernes Landsbank',
    '5386': 'Arbejdernes Landsbank',
    '5387': 'Arbejdernes Landsbank',
    '5388': 'Arbejdernes Landsbank',
    '5389': 'Arbejdernes Landsbank',
    '5390': 'Arbejdernes Landsbank',
    '5391': 'Arbejdernes Landsbank',
    '5392': 'Arbejdernes Landsbank',
    '5393': 'Arbejdernes Landsbank',
    '5394': 'Arbejdernes Landsbank',
    '5395': 'Arbejdernes Landsbank',
    '5396': 'Arbejdernes Landsbank',
    '5397': 'Arbejdernes Landsbank',
    '5398': 'Arbejdernes Landsbank',
    '5400': 'Sydbank',
    '5420': 'The Royal Bank of Scotland',
    '5426': 'Alfred Berg Bank A/S',
    '5451': 'Sammenslutningen af Danske Andelskasser',
    '5470': 'Nykredit Bank',
    '5471': 'Nykredit Bank',
    '5472': 'Nykredit Bank',
    '5473': 'Nykredit Bank',
    '5474': 'Nykredit Bank',
    '5475': 'Nykredit Bank',
    '5476': 'Nykredit Bank',
    '5478': 'Nykredit Bank',
    '5479': 'Nykredit Bank',
    '5490': 'Nykredit Bank',
    '5491': 'Nykredit Bank',
    '5492': 'Nykredit Bank',
    '5493': 'Nykredit Bank',
    '5494': 'Nykredit Bank',
    '5495': 'Nykredit Bank',
    '5496': 'Nykredit Bank',
    '5497': 'Nykredit Bank',
    '5499': 'Nykredit Bank',
    '5501': 'Nordea',
    '5502': 'Nordea',
    '5503': 'Nordea',
    '5504': 'Nordea',
    '5505': 'Nordea',
    '5506': 'Nordea',
    '5507': 'Nordea',
    '5508': 'Nordea',
    '5509': 'Nordea',
    '5510': 'Nordea',
    '5512': 'Nordea',
    '5513': 'Nordea',
    '5514': 'Nordea',
    '5515': 'Nordea',
    '5516': 'Nordea',
    '5518': 'Nordea',
    '5520': 'Nordea',
    '5521': 'Nordea',
    '5523': 'Nordea',
    '5524': 'Nordea',
    '5525': 'Nordea',
    '5526': 'Nordea',
    '5529': 'Nordea',
    '5530': 'Nordea',
    '5531': 'Nordea',
    '5532': 'Nordea',
    '5533': 'Nordea',
    '5534': 'Nordea',
    '5535': 'Nordea',
    '5537': 'Nordea',
    '5538': 'Nordea',
    '5539': 'Nordea',
    '5540': 'Nordea',
    '5541': 'Nordea',
    '5542': 'Nordea',
    '5543': 'Nordea',
    '5545': 'Nordea',
    '5546': 'Nordea',
    '5547': 'Nordea',
    '5548': 'Nordea',
    '5550': 'Nordea',
    '5551': 'Nordea',
    '5552': 'Nordea',
    '5553': 'Nordea',
    '5555': 'Nordea',
    '5556': 'Nordea',
    '5558': 'Nordea',
    '5559': 'Nordea',
    '5562': 'Nordea',
    '5563': 'Nordea',
    '5565': 'Nordea',
    '5567': 'Nordea',
    '5568': 'Nordea',
    '5570': 'Nordea',
    '5572': 'Nordea',
    '5574': 'Nordea',
    '5575': 'Nordea',
    '5578': 'Nordea',
    '5580': 'Nordea',
    '5581': 'Nordea',
    '5582': 'Nordea',
    '5583': 'Nordea',
    '5584': 'Nordea',
    '5585': 'Nordea',
    '5586': 'Nordea',
    '5588': 'Nordea',
    '5591': 'Nordea',
    '5592': 'Nordea',
    '5594': 'Nordea',
    '5595': 'Nordea',
    '5596': 'Nordea',
    '5597': 'Nordea',
    '5598': 'Nordea',
    '5600': 'Nordea',
    '5601': 'Nordea',
    '5603': 'Nordea',
    '5605': 'Nordea',
    '5606': 'Nordea',
    '5607': 'Nordea',
    '5608': 'Nordea',
    '5609': 'Nordea',
    '5610': 'Nordea',
    '5611': 'Nordea',
    '5612': 'Nordea',
    '5613': 'Nordea',
    '5615': 'Nordea',
    '5616': 'Nordea',
    '5620': 'Nordea',
    '5621': 'Nordea',
    '5622': 'Nordea',
    '5623': 'Nordea',
    '5624': 'Nordea',
    '5625': 'Nordea',
    '5627': 'Nordea',
    '5629': 'Nordea',
    '5630': 'Nordea',
    '5631': 'Nordea',
    '5632': 'Nordea',
    '5633': 'Nordea',
    '5634': 'Nordea',
    '5635': 'Nordea',
    '5637': 'Nordea',
    '5640': 'Nordea',
    '5641': 'Nordea',
    '5642': 'Nordea',
    '5643': 'Nordea',
    '5645': 'Nordea',
    '5647': 'Nordea',
    '5648': 'Nordea',
    '5650': 'Nordea',
    '5651': 'Nordea',
    '5653': 'Nordea',
    '5655': 'Nordea',
    '5656': 'Nordea',
    '5658': 'Nordea',
    '5659': 'Nordea',
    '5660': 'Nordea',
    '5661': 'Nordea',
    '5663': 'Nordea',
    '5664': 'Nordea',
    '5665': 'Nordea',
    '5666': 'Nordea',
    '5667': 'Nordea',
    '5670': 'Nordea',
    '5671': 'Nordea',
    '5675': 'Nordea',
    '5677': 'Nordea',
    '5678': 'Nordea',
    '5680': 'Nordea',
    '5682': 'Nordea Bank',
    '5683': 'Nordea',
    '5686': 'Nordea',
    '5690': 'Nordea',
    '5694': 'Nordea',
    '5695': 'Nordea',
    '5697': 'Nordea',
    '5698': 'Nordea',
    '5699': 'Nordea',
    '5700': 'Nordea',
    '5702': 'Nordea',
    '5704': 'Nordea',
    '5705': 'Nordea',
    '5706': 'Nordea',
    '5707': 'Nordea',
    '5710': 'Nordea',
    '5711': 'Nordea',
    '5714': 'Nordea',
    '5715': 'Nordea',
    '5716': 'Nordea',
    '5717': 'Nordea',
    '5719': 'Nordea',
    '5720': 'Nordea',
    '5722': 'Nordea',
    '5723': 'Nordea',
    '5726': 'Nordea',
    '5730': 'Nordea',
    '5732': 'Nordea',
    '5733': 'Nordea',
    '5735': 'Nordea',
    '5736': 'Nordea',
    '5738': 'Nordea',
    '5739': 'Nordea',
    '5740': 'Nordea',
    '5742': 'Nordea',
    '5743': 'Nordea',
    '5744': 'Nordea',
    '5749': 'Nordea',
    '5750': 'Nordea',
    '5751': 'Nordea',
    '5752': 'Nordea',
    '5753': 'Nordea',
    '5760': 'Nordea',
    '5762': 'Nordea',
    '5763': 'Nordea',
    '5764': 'Nordea',
    '5768': 'Nordea',
    '5772': 'Nordea',
    '5773': 'Nordea',
    '5774': 'Nordea',
    '5775': 'Nordea',
    '5779': 'Nordea',
    '5780': 'Nordea',
    '5781': 'Nordea',
    '5785': 'Nordea',
    '5787': 'Nordea',
    '5790': 'Nordea',
    '5791': 'Nordea',
    '5800': 'Nordea',
    '5801': 'Nordea',
    '5803': 'Nordea',
    '5804': 'Nordea',
    '5807': 'Nordea',
    '5808': 'Nordea',
    '5810': 'Nordea',
    '5811': 'Nordea',
    '5812': 'Nordea',
    '5813': 'Nordea',
    '5815': 'Nordea',
    '5819': 'Nordea',
    '5820': 'Nordea',
    '5821': 'Nordea',
    '5822': 'Nordea',
    '5825': 'Nordea',
    '5826': 'Nordea',
    '5827': 'Nordea',
    '5834': 'Nordea',
    '5835': 'Nordea',
    '5844': 'Nordea',
    '5850': 'Nordea',
    '5855': 'Nordea',
    '5860': 'Nordea',
    '5862': 'Nordea',
    '5863': 'Nordea',
    '5864': 'Nordea',
    '5867': 'Nordea',
    '5870': 'Nordea',
    '5875': 'Nordea',
    '5880': 'Nordea',
    '5881': 'Nordea',
    '5882': 'Nordea',
    '5890': 'Nordea',
    '5900': 'Nordea',
    '5908': 'Nordea',
    '5910': 'Nordea',
    '5911': 'Nordea',
    '5912': 'Nordea',
    '5913': 'Nordea',
    '5915': 'Nordea',
    '5916': 'Nordea',
    '5917': 'Nordea',
    '5919': 'Nordea',
    '5920': 'Nordea',
    '5922': 'Nordea',
    '5923': 'Nordea',
    '5929': 'Nordea',
    '5930': 'Nordea',
    '5932': 'Nordea',
    '5934': 'Nordea',
    '5935': 'Nordea',
    '5938': 'Nordea',
    '5939': 'Nordea',
    '5941': 'Nordea',
    '5942': 'Nordea',
    '5944': 'Nordea',
    '5947': 'Nordea',
    '5948': 'Nordea',
    '5949': 'Nordea',
    '5950': 'Danske Andelskassers Bank',
    '5951': 'Danske Andelskassers Bank',
    '5952': 'Danske Andelskassers Bank',
    '5953': 'Danske Andelskassers Bank',
    '5954': 'Danske Andelskassers Bank',
    '5955': 'Danske Andelskassers Bank',
    '5957': 'Danske Andelskassers Bank',
    '5958': 'Faster Andelskasse',
    '5959': 'Danske Andelskassers Bank',
    '5960': 'Frørup Andelskasse',
    '5961': 'Danske Andelskassers Bank',
    '5966': 'Danske Andelskassers Bank',
    '5967': 'Danske Andelskassers Bank',
    '5969': 'Danske Andelskassers Bank',
    '5970': 'Danske Andelskassers Bank',
    '5971': 'Danske Andelskassers Bank',
    '5974': 'Danske Andelskassers Bank',
    '5975': 'Danske Andelskassers Bank',
    '5976': 'Danske Andelskassers Bank',
    '5977': 'Danske Andelskassers Bank',
    '5979': 'Danske Andelskassers Bank',
    '5980': 'Danske Andelskassers Bank',
    '5982': 'Danske Andelskassers Bank',
    '5983': 'Danske Andelskassers Bank',
    '5984': 'Danske Andelskassers Bank',
    '5985': 'Danske Andelskassers Bank',
    '5986': 'Danske Andelskassers Bank',
    '5987': 'Danske Andelskassers Bank',
    '5988': 'Sparekassen Faaborg',
    '5989': 'Danske Andelskassers Bank',
    '5990': 'Danske Andelskassers Bank',
    '5991': 'Danske Andelskassers Bank',
    '5993': 'Danske Andelskassers Bank',
    '5994': 'Danske Andelskassers Bank',
    '5995': 'Danske Andelskassers Bank',
    '5996': 'Danske Andelskassers Bank',
    '5997': 'Danske Andelskassers Bank',
    '5998': 'Danske Andelskassers Bank',
    '5999': 'Danske Andelskassers Bank',
    '6004': 'Swedbank',
    '6010': 'Cargill Bank',
    '6011': 'Swedbank',
    '6012': 'J.P. Morgan Europa (UK) København',
    '6060': 'Sydbank',
    '6070': 'Sparekassen Sjælland',
    '6075': 'Sparekassen Sjælland',
    '6085': 'Sparekassen Sjælland',
    '6100': 'Skandinaviska Enskilda Banken',
    '6110': 'Sparekassen Kronjylland',
    '6111': 'Sparekassen Kronjylland',
    '6112': 'Sparekassen Kronjylland',
    '6113': 'Sparekassen Kronjylland',
    '6114': 'Sparekassen Kronjylland',
    '6115': 'Sparekassen Kronjylland',
    '6116': 'Sparekassen Kronjylland',
    '6117': 'Sparekassen Kronjylland',
    '6119': 'Sparekassen Kronjylland',
    '6120': 'Sparekassen Kronjylland',
    '6121': 'Sparekassen Kronjylland',
    '6122': 'Sparekassen Kronjylland',
    '6123': 'Sparekassen Kronjylland',
    '6124': 'Sparekassen Kronjylland',
    '6125': 'Sparekassen Kronjylland',
    '6126': 'Sparekassen Kronjylland',
    '6127': 'Sparekassen Kronjylland',
    '6128': 'Sparekassen Kronjylland',
    '6129': 'Sparekassen Kronjylland',
    '6130': 'Sparekassen Kronjylland',
    '6132': 'Sparekassen Kronjylland',
    '6140': 'Møns Bank',
    '6150': 'Sparekassen Sjælland',
    '6160': 'FS Bank',
    '6180': 'Sparekassen Kronjylland',
    '6181': 'Sparekassen Kronjylland',
    '6182': 'Sparekassen Kronjylland',
    '6183': 'Sparekassen Kronjylland',
    '6184': 'Sparekassen Kronjylland',
    '6185': 'Sparekassen Kronjylland',
    '6186': 'Sparekassen Kronjylland',
    '6187': 'Sparekassen Kronjylland',
    '6188': 'Sparekassen Kronjylland',
    '6189': 'Sparekassen Kronjylland',
    '6190': 'Sparekassen Kronjylland',
    '6191': 'Sparekassen Kronjylland',
    '6192': 'Sparekassen Kronjylland',
    '6193': 'Sparekassen Kronjylland',
    '6194': 'Sparekassen Kronjylland',
    '6220': 'Lollands Bank A/S',
    '6230': 'Sparekassen Kronjylland',
    '6231': 'Sparekassen Kronjylland',
    '6232': 'Sparekassen Kronjylland',
    '6233': 'Sparekassen Kronjylland',
    '6235': 'Sparekassen Kronjylland',
    '6237': 'Sparekassen Kronjylland',
    '6260': 'Jyske Bank',
    '6261': 'Jyske Bank',
    '6262': 'Jyske Bank',
    '6263': 'Jyske Bank',
    '6264': 'Jyske Bank',
    '6265': 'Jyske Bank',
    '6267': 'Jyske Bank',
    '6268': 'Jyske Bank',
    '6300': 'Handelsbanken',
    '6301': 'Handelsbanken',
    '6302': 'Handelsbanken',
    '6326': 'Jyske Bank',
    '6327': 'Jyske Bank',
    '6328': 'Jyske Bank',
    '6329': 'Jyske Bank',
    '6330': 'Jyske Bank',
    '6331': 'Jyske Bank',
    '6332': 'Jyske Bank',
    '6423': 'Danske Bank',
    '6424': 'Danske Bank',
    '6425': 'Danske Bank',
    '6460': 'Banknordik',
    '6471': 'Grønlandsbanken A/S',
    '6482': 'Finansnetbanken - Jyske Bank',
    '6483': 'Handelsbanken',
    '6484': 'Handelsbanken',
    '6485': 'Handelsbanken',
    '6486': 'Handelsbanken',
    '6487': 'Handelsbanken',
    '6488': 'Handelsbanken',
    '6489': 'Handelsbanken',
    '6490': 'Handelsbanken',
    '6491': 'Handelsbanken',
    '6492': 'Handelsbanken',
    '6493': 'Handelsbanken',
    '6494': 'Handelsbanken',
    '6495': 'Handelsbanken',
    '6496': 'Handelsbanken',
    '6497': 'Handelsbanken',
    '6499': 'Handelsbanken',
    '6500': 'Handelsbanken',
    '6503': 'BankNordik',
    '6504': 'BankNordik',
    '6505': 'BankNordik',
    '6506': 'BankNordik',
    '6507': 'BankNordik',
    '6508': 'BankNordik',
    '6509': 'BankNordik',
    '6510': 'BankNordik',
    '6511': 'BankNordik',
    '6512': 'BankNordik',
    '6513': 'BankNordik',
    '6514': 'BankNordik',
    '6515': 'BankNordik',
    '6516': 'BankNordik',
    '6520': 'Lollands Bank',
    '6525': 'Lollands Bank',
    '6540': 'FS Bank',
    '6541': 'FS Bank',
    '6542': 'FS Bank',
    '6543': 'FS Bank',
    '6610': 'Jyske Bank',
    '6612': 'Facit Bank',
    '6620': 'Coop Bank',
    '6680': 'Sparekassen Kronjylland',
    '6681': 'Sparekassen Kronjylland',
    '6682': 'Sparekassen Kronjylland, Holbæk',
    '6683': 'Sparekassen Kronjylland, Kolding',
    '6684': 'Sparekassen Kronjylland, Esbjerg',
    '6685': 'Sparekassen Kronjylland',
    '6686': 'Sparekassen Kronjylland',
    '6687': 'Sparekassen Kronjylland',
    '6690': 'Sparekassen Kronjylland',
    '6695': 'Lunar Bank A/S',
    '6735': 'Sydbank',
    '6736': 'Sydbank',
    '6737': 'Sydbank',
    '6738': 'Sydbank',
    '6739': 'Sydbank',
    '6743': 'Sydbank',
    '6748': 'Sydbank',
    '6749': 'Sydbank',
    '6771': 'Lægernes Bank A/S',
    '6810': 'Sydbank',
    '6811': 'Sydbank',
    '6812': 'Sydbank',
    '6813': 'Sydbank',
    '6814': 'Sydbank',
    '6815': 'Sydbank',
    '6816': 'Sydbank',
    '6817': 'Sydbank',
    '6818': 'Sydbank',
    '6819': 'Sydbank',
    '6820': 'Sydbank',
    '6821': 'Sydbank',
    '6822': 'Sydbank',
    '6823': 'Sydbank',
    '6824': 'Sydbank',
    '6825': 'Sydbank',
    '6826': 'Sydbank',
    '6840': 'Sydbank',
    '6845': 'Sydbank',
    '6847': 'Sydbank',
    '6848': 'Sydbank',
    '6850': 'Fynske Bank',
    '6851': 'Fynske Bank',
    '6852': 'Fynske Bank',
    '6853': 'Fynske Bank',
    '6854': 'Fynske Bank',
    '6855': 'Fynske Bank',
    '6856': 'Fynske Bank',
    '6857': 'Fynske Bank',
    '6858': 'Fynske Bank',
    '6859': 'Fynske Bank',
    '6860': 'Nordfyns Bank',
    '6861': 'Nordfyns Bank',
    '6862': 'Nordfyns Bank',
    '6863': 'Nordfyns Bank',
    '6864': 'Nordfyns Bank',
    '6865': 'Nordfyns Bank',
    '6866': 'Nordfyns Bank',
    '6867': 'Nordfyns Bank',
    '6868': 'Nordfyns Bank',
    '6869': 'Nordfyns Bank',
    '6880': 'Totalbanken A/S',
    '6958': 'Danske Bank',
    '6961': 'Danske Bank',
    '6962': 'Danske Bank',
    '7000': 'FS Bank',
    '7001': 'FS Bank',
    '7002': 'FS Bank',
    '7015': 'Jyske Bank',
    '7016': 'Jyske Bank',
    '7018': 'Jyske Bank A/S',
    '7030': 'Sydbank',
    '7031': 'Sydbank',
    '7032': 'Sydbank',
    '7034': 'Sydbank',
    '7035': 'Sydbank',
    '7036': 'Sydbank',
    '7037': 'Sydbank',
    '7038': 'Sydbank',
    '7039': 'Sydbank',
    '7040': 'Sydbank',
    '7041': 'Sydbank',
    '7043': 'Sydbank',
    '7045': 'Sydbank',
    '7046': 'Sydbank',
    '7050': 'Sydbank',
    '7051': 'Sydbank',
    '7055': 'Sydbank',
    '7059': 'Sydbank',
    '7109': 'Danske Bank',
    '7110': 'Sydbank',
    '7116': 'Sydbank',
    '7117': 'Sydbank',
    '7118': 'Sydbank',
    '7120': 'Sydbank',
    '7121': 'Sydbank',
    '7123': 'Sydbank',
    '7124': 'Sydbank',
    '7125': 'Sydbank',
    '7126': 'Sydbank',
    '7127': 'Sydbank',
    '7128': 'Sydbank',
    '7130': 'Spar Nord',
    '7131': 'Spar Nord',
    '7132': 'Jyske Bank',
    '7133': 'Jyske Bank',
    '7134': 'Jyske Bank',
    '7135': 'Jyske Bank',
    '7136': 'Jyske Bank',
    '7137': 'Jyske Bank',
    '7138': 'Jyske Bank',
    '7139': 'Jyske Bank',
    '7140': 'Sydbank',
    '7160': 'Sydbank',
    '7161': 'Sydbank',
    '7170': 'Jyske Bank',
    '7171': 'Jyske Bank',
    '7172': 'Jyske Bank',
    '7173': 'Jyske Bank',
    '7174': 'Jyske Bank',
    '7175': 'Jyske Bank',
    '7176': 'Jyske Bank',
    '7177': 'Jyske Bank',
    '7178': 'Jyske Bank',
    '7179': 'Jyske Bank',
    '7181': 'Jyske Bank',
    '7182': 'Jyske Bank',
    '7183': 'Jyske Bank',
    '7184': 'Jyske Bank',
    '7185': 'Jyske Bank',
    '7186': 'Jyske Bank',
    '7187': 'Jyske Bank',
    '7220': 'Spar Nord',
    '7230': 'Østjydsk Bank',
    '7240': 'Jyske Bank',
    '7241': 'Jyske Bank',
    '7242': 'Jyske Bank',
    '7243': 'Jyske Bank',
    '7244': 'Jyske Bank',
    '7245': 'Jyske Bank',
    '7247': 'Jyske Bank',
    '7248': 'Jyske Bank',
    '7249': 'Jyske Bank',
    '7250': 'Jyske Bank',
    '7251': 'Jyske Bank',
    '7252': 'Jyske Bank',
    '7253': 'Jyske Bank',
    '7254': 'Jyske Bank',
    '7255': 'Jyske Bank',
    '7256': 'Jyske Bank',
    '7257': 'Jyske Bank',
    '7258': 'Jyske Bank',
    '7259': 'Jyske Bank',
    '7260': 'Djurslands Bank',
    '7261': 'Djurslands Bank',
    '7262': 'Djurslands Bank',
    '7263': 'Djurslands Bank',
    '7264': 'Djurslands Bank',
    '7265': 'Djurslands Bank',
    '7266': 'Djurslands Bank',
    '7267': 'Djurslands Bank',
    '7268': 'Djurslands Bank',
    '7270': 'Vestjysk Bank',
    '7300': 'Djurslands Bank',
    '7301': 'Djurslands Bank',
    '7305': 'Djurslands Bank',
    '7309': 'Djurslands Bank',
    '7310': 'Jyske Bank',
    '7312': 'Jyske Bank',
    '7313': 'Jyske Bank',
    '7316': 'Jyske Bank',
    '7318': 'Jyske Bank',
    '7319': 'Jyske Bank',
    '7320': 'Djurslands Bank',
    '7321': 'Djurslands Bank',
    '7360': 'Jyske Bank',
    '7361': 'Jyske Bank',
    '7362': 'Jyske Bank',
    '7363': 'Jyske Bank',
    '7364': 'Jyske Bank',
    '7365': 'Jyske Bank',
    '7366': 'Jyske Bank',
    '7367': 'Jyske Bank',
    '7368': 'Jyske Bank',
    '7369': 'Jyske Bank',
    '7370': 'Nordjyske Bank',
    '7371': 'Nordjyske Bank',
    '7372': 'Nordjyske Bank',
    '7375': 'Nordjyske Bank',
    '7379': 'Nordjyske Bank',
    '7380': 'Jyske Bank',
    '7381': 'Den Jyske Sparekasse',
    '7382': 'Den Jyske Sparekasse',
    '7383': 'Den Jyske Sparekasse',
    '7384': 'Den Jyske Sparekasse',
    '7385': 'Den Jyske Sparekasse',
    '7386': 'Den Jyske Sparekasse',
    '7387': 'Den Jyske Sparekasse',
    '7391': 'Den Jyske Sparekasse',
    '7392': 'Den Jyske Sparekasse',
    '7393': 'Den Jyske Sparekasse',
    '7396': 'Den Jyske Sparekasse',
    '7397': 'Den Jyske Sparekasse',
    '7399': 'Den Jyske Sparekasse',
    '7400': 'Nordjyske Bank',
    '7401': 'Nordjyske Bank',
    '7402': 'Nordjyske Bank',
    '7403': 'Nordjyske Bank',
    '7405': 'Nordjyske Bank',
    '7406': 'Nordjyske Bank',
    '7407': 'Nordjyske Bank',
    '7410': 'Jutlander Bank',
    '7413': 'Jyske Bank A/S',
    '7414': 'Jyske Bank',
    '7415': 'Jyske Bank',
    '7417': 'Jyske Bank',
    '7418': 'Jyske Bank',
    '7420': 'Nordjyske Bank',
    '7421': 'Nordjyske Bank',
    '7422': 'Nordjyske Bank',
    '7423': 'Nordjyske Bank',
    '7428': 'Nordjyske Bank',
    '7432': 'Nordjyske Bank',
    '7433': 'Nordjyske Bank',
    '7434': 'Nordjyske Bank',
    '7435': 'Nordjyske Bank',
    '7436': 'Nordjyske Bank',
    '7440': 'Nordjyske Bank',
    '7441': 'Nordjyske Bank',
    '7442': 'Nordjyske Bank',
    '7443': 'Nordjyske Bank',
    '7444': 'Nordjyske Bank',
    '7445': 'Nordjyske Bank',
    '7446': 'Nordjyske Bank',
    '7447': 'Nordjyske Bank',
    '7448': 'Nordjyske Bank',
    '7449': 'Nordjyske Bank',
    '7450': 'Nordjyske Bank',
    '7451': 'Nordjyske Bank',
    '7452': 'Nordjyske Bank',
    '7453': 'Nordjyske Bank',
    '7454': 'Nordjyske Bank',
    '7455': 'Nordjyske Bank',
    '7456': 'Nordjyske Bank',
    '7457': 'Nordjyske Bank',
    '7458': 'Nordjyske Bank',
    '7459': 'Nordjyske Bank',
    '7461': 'Jutlander Bank',
    '7465': 'Jyske Bank',
    '7470': 'Spar Nord',
    '7471': 'Spar Nord',
    '7500': 'Hvidbjerg Bank',
    '7530': 'Nordjyske Bank',
    '7531': 'Nordjyske Bank',
    '7535': 'Nordjyske Bank',
    '7540': 'Jyske Bank',
    '7541': 'Jyske Bank',
    '7543': 'Jyske Bank',
    '7545': 'Jyske Bank',
    '7546': 'Jyske Bank',
    '7547': 'Jyske Bank',
    '7554': 'Jyske Bank',
    '7555': 'Jyske Bank',
    '7556': 'Jyske Bank',
    '7561': 'Jyske Bank',
    '7562': 'Jyske Bank',
    '7570': 'Pen-Sam Bank',
    '7572': 'Frøs Herreds Sparekasse',
    '7573': 'Frøs Herreds Sparekasse',
    '7575': 'Alm. Brand Bank',
    '7590': 'Jyske Bank',
    '7591': 'Jyske Bank',
    '7593': 'Jyske Bank',
    '7595': 'Jyske Bank',
    '7596': 'Jyske Bank',
    '7597': 'Jyske Bank',
    '7598': 'Jyske Bank',
    '7599': 'Jyske Bank',
    '7600': 'Vestjysk Bank',
    '7601': 'vestjyskBANK',
    '7602': 'vestjyskBANK',
    '7603': 'vestjyskBANK',
    '7604': 'vestjyskBANK',
    '7605': 'vestjyskBANK',
    '7606': 'vestjyskBANK',
    '7607': 'vestjyskBANK',
    '7608': 'vestjyskBANK',
    '7610': 'Handelsbanken',
    '7611': 'Handelsbanken',
    '7612': 'Handelsbanken',
    '7613': 'Handelsbanken',
    '7614': 'Handelsbanken',
    '7615': 'Handelsbanken',
    '7616': 'Handelsbanken',
    '7617': 'Handelsbanken',
    '7618': 'Handelsbanken',
    '7619': 'Handelsbanken',
    '7620': 'Handelsbanken',
    '7621': 'Handelsbanken',
    '7622': 'Handelsbanken',
    '7623': 'Handelsbanken',
    '7624': 'Handelsbanken',
    '7625': 'Handelsbanken',
    '7627': 'Handelsbanken',
    '7629': 'Handelsbanken',
    '7630': 'Handelsbanken',
    '7631': 'Handelsbanken',
    '7632': 'Handelsbanken',
    '7633': 'Handelsbanken',
    '7634': 'Handelsbanken',
    '7635': 'Handelsbanken',
    '7636': 'Handelsbanken',
    '7637': 'Handelsbanken',
    '7638': 'Handelsbanken',
    '7639': 'Handelsbanken',
    '7640': 'Handelsbanken',
    '7641': 'Handelsbanken',
    '7642': 'Handelsbanken',
    '7643': 'Handelsbanken',
    '7644': 'Handelsbanken',
    '7646': 'Handelsbanken',
    '7647': 'Handelsbanken',
    '7648': 'Handelsbanken',
    '7649': 'Handelsbanken',
    '7650': 'vestjyskBANK',
    '7651': 'vestjyskBANK',
    '7652': 'vestjyskBANK',
    '7653': 'vestjyskBANK',
    '7654': 'vestjyskBANK',
    '7655': 'vestjyskBANK',
    '7656': 'vestjyskBANK',
    '7657': 'Vestjysk Bank',
    '7660': 'vestjyskBANK',
    '7670': 'Ringkjøbing Landbobank',
    '7679': 'Ringkjøbing Landbobank',
    '7680': 'vestjyskBANK',
    '7681': 'Alm. Brand Bank',
    '7685': 'Frøs Sparekasse',
    '7700': 'Sydbank',
    '7701': 'Sydbank',
    '7702': 'Sydbank',
    '7703': 'Sydbank',
    '7704': 'Sydbank',
    '7705': 'Sydbank',
    '7708': 'Sydbank',
    '7710': 'Sydbank',
    '7711': 'Sydbank',
    '7712': 'Sydbank',
    '7713': 'Sydbank',
    '7714': 'Sydbank',
    '7715': 'Sydbank',
    '7716': 'Sydbank',
    '7717': 'Sydbank',
    '7718': 'Sydbank',
    '7724': 'Danske Andelskassers Bank',
    '7725': 'Danske Andelskassers Bank',
    '7726': 'Danske Andelskassers Bank',
    '7729': 'Danske Andelskassers Bank',
    '7730': 'vestjyskBANK',
    '7732': 'vestjyskBANK',
    '7733': 'vestjyskBANK',
    '7734': 'vestjyskBANK',
    '7735': 'vestjyskBANK',
    '7736': 'vestjyskBANK',
    '7737': 'vestjyskBANK',
    '7738': 'vestjyskBANK',
    '7739': 'vestjyskBANK',
    '7740': 'vestjyskBANK',
    '7747': 'vestjyskBANK',
    '7749': 'vestjyskBANK',
    '7750': 'Jyske Bank',
    '7751': 'Jyske Bank',
    '7753': 'Jyske Bank',
    '7754': 'Jyske Bank',
    '7755': 'Jyske Bank',
    '7780': 'Skjern Bank',
    '7788': 'Danske Andelskassers Bank',
    '7789': 'Danske Andelskassers Bank',
    '7790': 'Salling Bank',
    '7800': 'Rinkjøbing Landbobank',
    '7810': 'Sydbank',
    '7811': 'Sydbank',
    '7821': 'Jyske Bank',
    '7822': 'Jyske Bank',
    '7829': 'Jyske Bank',
    '7830': 'Jyske Bank',
    '7831': 'Jyske Bank',
    '7833': 'Jyske Bank',
    '7834': 'Jyske Bank',
    '7835': 'Jyske Bank',
    '7836': 'Jyske Bank',
    '7837': 'Jyske Bank',
    '7840': 'Jyske Bank',
    '7841': 'Jyske Bank',
    '7842': 'Jyske Bank',
    '7843': 'Jyske Bank',
    '7844': 'Jyske Bank',
    '7845': 'Jyske Bank',
    '7846': 'Jyske Bank',
    '7849': 'Jyske Bank',
    '7851': 'Jyske Bank',
    '7852': 'Jyske Bank',
    '7853': 'Jyske Bank',
    '7854': 'Jyske Bank',
    '7856': 'Jyske Bank',
    '7857': 'Jyske Bank',
    '7858': 'Jyske Bank',
    '7860': 'Sydbank',
    '7872': 'Københavns Andelskasse',
    '7890': 'Salling Bank',
    '7910': 'Sydbank',
    '7911': 'Sydbank',
    '7915': 'Sydbank',
    '7920': 'Sydbank',
    '7921': 'Sydbank',
    '7922': 'Sydbank',
    '7925': 'Sydbank',
    '7930': 'Kreditbanken',
    '7931': 'Kreditbanken',
    '7932': 'Kreditbanken',
    '7933': 'Kreditbanken',
    '7951': 'Saxo Privatbank',
    '7952': 'Saxo Privatbank',
    '7953': 'Saxo Privatbank',
    '7954': 'Saxo Privatbank',
    '7955': 'Saxo Privatbank',
    '7956': 'Saxo Privatbank A/S',
    '7957': 'Saxo Privatbank',
    '7959': 'Københavns Andelskasse',
    '7970': 'Sydbank',
    '7971': 'Sydbank',
    '7980': 'Sydbank',
    '7981': 'Sydbank',
    '7982': 'Sydbank',
    '7990': 'Sydbank',
    '8010': 'Sydbank',
    '8011': 'Sydbank',
    '8012': 'Sydbank',
    '8013': 'Sydbank',
    '8020': 'Sydbank',
    '8060': 'Sydbank',
    '8061': 'Sydbank',
    '8063': 'Sydbank',
    '8065': 'Sydbank',
    '8066': 'Sydbank',
    '8068': 'Sydbank',
    '8071': 'Sydbank',
    '8072': 'Sydbank',
    '8075': 'Sydbank',
    '8076': 'Sydbank',
    '8077': 'Sydbank',
    '8079': 'Sydbank',
    '8090': 'Nordjyske Bank',
    '8091': 'Nordjyske Bank',
    '8099': 'Nordjyske Bank',
    '8109': 'Jyske Bank',
    '8113': 'Nykredit Bank',
    '8114': 'Nykredit Bank',
    '8117': 'Nykredit Bank',
    '8119': 'BankNordik',
    '8120': 'BankNordik',
    '8121': 'BankNordik',
    '8122': 'Spar Nord',
    '8123': 'Spar Nord',
    '8124': 'BankNordik',
    '8125': 'Spar Nord',
    '8126': 'BankNordik',
    '8127': 'BankNordik',
    '8128': 'Nykredit Bank',
    '8129': 'Nykredit Bank',
    '8130': 'Den Jyske Sparekasse',
    '8131': 'Den Jyske Sparekasse',
    '8132': 'Den Jyske Sparekasse',
    '8133': 'Den Jyske Sparekasse',
    '8139': 'Sparekassen Hobro',
    '8140': 'Jutlander Bank',
    '8141': 'Sparekassen Hobro',
    '8142': 'Sparekassen Hobro',
    '8143': 'Sparekassen Hobro',
    '8144': 'Sparekassen Hobro',
    '8145': 'Sparekassen Hobro',
    '8146': 'Saxo Privatbank',
    '8147': 'Saxo Privatbank',
    '8148': 'Saxo Privatbank',
    '8149': 'Bnp Paribas Fortis Danmark',
    '8205': 'Den Jyske Sparekasse',
    '8210': 'Den Jyske Sparekasse',
    '8211': 'Den Jyske Sparekasse',
    '8212': 'Den Jyske Sparekasse',
    '8213': 'Den Jyske Sparekasse',
    '8214': 'Den Jyske Sparekasse',
    '8215': 'Den Jyske Sparekasse',
    '8220': 'Den Jyske Sparekasse',
    '8222': 'Banque Internationale',
    '8223': 'Den Jyske Sparekasse',
    '8224': 'Den Jyske Sparekasse',
    '8230': 'Fih Erhvervsbank',
    '8232': 'Fih Erhvervsbank',
    '8269': 'Carnegie Bank',
    '8401': 'Merkur',
    '8411': 'Andelskassen Fælleskassen',
    '8412': 'J.A.K. Andelskasse',
    '8418': 'Andelskassen Oikos',
    '8460': 'Nordjyske Bank',
    '8461': 'Nordjyske Bank',
    '8480': 'Spar Nord',
    '8481': 'Spar Nord',
    '8482': 'Spar Nord',
    '8483': 'Spar Nord',
    '8484': 'Spar Nord',
    '8485': 'Spar Nord',
    '8486': 'Spar Nord',
    '8487': 'Spar Nord',
    '8489': 'Spar Nord',
    '8490': 'BankNordik',
    '8491': 'Spar Nord',
    '8492': 'Spar Nord',
    '8493': 'Spar Nord',
    '8494': 'Spar Nord',
    '8495': 'Spar Nord',
    '8496': 'Spar Nord',
    '8497': 'Spar Nord',
    '8498': 'Spar Nord',
    '8499': 'Spar Nord',
    '8500': 'Spar Nord',
    '8501': 'Spar Nord',
    '8502': 'Spar Nord',
    '8503': 'Spar Nord',
    '8504': 'Spar Nord',
    '8505': 'Spar Nord',
    '8506': 'Spar Nord',
    '8507': 'Spar Nord',
    '8508': 'Spar Nord',
    '8509': 'Spar Nord',
    '8510': 'Spar Nord',
    '8514': 'Spar Nord',
    '8515': 'Spar Nord',
    '8516': 'Spar Nord',
    '8517': 'Spar Nord',
    '8518': 'Spar Nord',
    '8519': 'Spar Nord',
    '8520': 'Spar Nord',
    '8521': 'Spar Nord',
    '8522': 'Spar Nord',
    '8523': 'Spar Nord',
    '8524': 'Spar Nord',
    '8525': 'Spar Nord',
    '8526': 'Spar Nord',
    '8527': 'Spar Nord',
    '8528': 'Spar Nord',
    '8529': 'Spar Nord',
    '8530': 'Spar Nord',
    '9001': 'Spar Nord',
    '9002': 'Spar Nord',
    '9004': 'Spar Nord',
    '9006': 'Spar Nord',
    '9007': 'Spar Nord',
    '9008': 'Spar Nord',
    '9009': 'Spar Nord',
    '9010': 'Spar Nord',
    '9011': 'Spar Nord',
    '9012': 'Spar Nord',
    '9015': 'Spar Nord',
    '9016': 'Spar Nord',
    '9020': 'Sparekassen Vendsyssel',
    '9022': 'Brovst Sparekasse',
    '9024': 'Nordjyske Bank A/S',
    '9025': 'Jerslev Sparekasse',
    '9028': 'Spar Nord',
    '9029': 'Spar Nord',
    '9033': 'Nordjyske Bank A/S',
    '9035': 'Spar Nord',
    '9037': 'Spar Nord',
    '9040': 'Spar Nord',
    '9041': 'Danske Bank',
    '9043': 'TeliaSonera Finans Danmark',
    '9044': 'Dronninglund Sparekasse',
    '9046': 'Spar Nord',
    '9049': 'Spar Nord',
    '9050': 'Spar Nord',
    '9053': 'Hellevad-Ørum Sparekasse',
    '9054': 'Spar Nord',
    '9056': 'Spar Nord',
    '9057': 'Danske Bank',
    '9060': 'Spar Nord',
    '9061': 'Spar Nord',
    '9066': 'Spar Nord',
    '9067': 'Spar Nord',
    '9070': 'Sparekassen Vendsyssel',
    '9075': 'Spar Nord',
    '9076': 'Spar Nord',
    '9077': 'Spar Nord',
    '9078': 'Spar Nord',
    '9080': 'FS Bank',
    '9081': 'Sparekassen Thy',
    '9083': 'Sparekassen Thy',
    '9086': 'Sparekassen Thy',
    '9087': 'Sparekassen Thy',
    '9088': 'Sparekassen Thy',
    '9089': 'Sparekassen Thy',
    '9090': 'Sparekassen Thy',
    '9100': 'Jyske Bank',
    '9101': 'Spar Nord',
    '9102': 'Spar Nord',
    '9106': 'Sparekassen Thy',
    '9107': 'Sparekassen Thy',
    '9108': 'Sparekassen Thy',
    '9109': 'Sparekassen Thy',
    '9110': 'Sparekassen Thy',
    '9111': 'Sparekassen Thy',
    '9112': 'Sparekassen Thy',
    '9114': 'Sparekassen Thy',
    '9116': 'Sparekassen Vendsyssel',
    '9117': 'Frøslev-Mollerup Sparekasse',
    '9118': 'Sparekassen Thy',
    '9119': 'Sparekassen Thy',
    '9120': 'Sparekassen Thy',
    '9121': 'Boddum-Ydby Sparekasse',
    '9124': 'Sønderhå-Hørsted Sparekasse',
    '9127': 'Spar Nord',
    '9128': 'Spar Nord',
    '9129': 'Sparekassen Thy',
    '9133': 'Frøslev-Mollerup Sparekasse',
    '9135': 'Klim Sparekasse',
    '9139': 'Sparekassen Spar Mors',
    '9140': 'Sparekassen Vendsyssel',
    '9141': 'Sparekassen Vendsyssel',
    '9143': 'Hunstrup-Østerild Sparekasse',
    '9156': 'Spar Nord',
    '9160': 'Spar Nord',
    '9161': 'Nordea',
    '9162': 'Nordea',
    '9163': 'Nordea',
    '9164': 'Nordea',
    '9170': 'Danske Bank',
    '9173': 'Danske Bank',
    '9174': 'Den Jyske Sparekasse',
    '9181': 'Eik Banki P/f',
    '9189': 'EIK Bank A/S',
    '9190': 'Spar Nord',
    '9196': 'Spar Nord',
    '9200': 'Spar Nord',
    '9201': 'Jutlander Bank',
    '9202': 'Jutlander Bank',
    '9203': 'Jutlander Bank',
    '9206': 'Danske Bank',
    '9208': 'Danske Bank',
    '9209': 'Danske Bank',
    '9210': 'Spar Nord',
    '9211': 'Spar Nord',
    '9212': 'Hals Sparekasse',
    '9213': 'Spar Nord',
    '9214': 'Jutlander Bank',
    '9215': 'Spar Nord',
    '9216': 'Jutlander Bank',
    '9217': 'Jutlander Bank',
    '9218': 'Jutlander Bank',
    '9219': 'Spar Nord',
    '9221': 'Spar Nord',
    '9223': 'Sparekassen Hobro',
    '9224': 'Ulsted Sparekasse',
    '9225': 'Spar Nord',
    '9226': 'Spar Nord',
    '9227': 'Spar Nord',
    '9231': 'Jutlander Bank',
    '9233': 'Spar Nord',
    '9235': 'Jutlander Bank A/S',
    '9236': 'Spar Nord',
    '9237': 'Spar Nord',
    '9238': 'Jutlander Bank',
    '9239': 'Danske Bank',
    '9240': 'Spar Nord',
    '9241': 'Spar Nord',
    '9242': 'Spar Nord',
    '9243': 'Spar Nord',
    '9244': 'Spar Nord',
    '9245': 'Spar Nord',
    '9246': 'Spar Nord',
    '9247': 'Danske Bank',
    '9249': 'Danske Bank',
    '9251': 'Nordea',
    '9252': 'Nordea',
    '9254': 'Nordea',
    '9255': 'Nordea',
    '9256': 'Spar Nord',
    '9258': 'Spar Nord',
    '9259': 'Spar Nord',
    '9260': 'Spar Nord',
    '9261': 'Den Jyske Sparekasse',
    '9265': 'Nordea',
    '9266': 'Nordea',
    '9268': 'Danske Bank',
    '9269': 'Danske Bank',
    '9272': 'Nordea',
    '9274': 'Nordea',
    '9275': 'Nordea',
    '9277': 'Spar Nord',
    '9278': 'Spar Nord',
    '9279': 'Danske Bank',
    '9280': 'Spar Nord',
    '9281': 'Danske Bank',
    '9282': 'Spar Nord',
    '9283': 'Langå Sparekasse',
    '9284': 'Nordea',
    '9285': 'Fuur Sparekasse',
    '9286': 'Spar Nord',
    '9287': 'Spar Nord',
    '9289': 'Spar Nord',
    '9291': 'Roslev Sparekasse',
    '9292': 'Sparekassen Sundsøre',
    '9294': 'Sparekassen Kronjylland',
    '9296': 'Spar Nord',
    '9297': 'Spar Nord',
    '9298': 'Sparekassen Kronjylland',
    '9299': 'Nordea',
    '9301': 'Spar Nord',
    '9302': 'Spar Nord',
    '9303': 'Sparekassen Hobro',
    '9304': 'Spar Nord',
    '9306': 'Spar Nord',
    '9307': 'Den Jyske Sparekasse',
    '9308': 'Spar Nord',
    '9309': 'Spar Nord',
    '9310': 'Nordea',
    '9311': 'Spar Nord',
    '9312': 'Sparekassen Balling',
    '9313': 'Durup Sparekasse',
    '9314': 'Spar Nord',
    '9315': 'Danske Bank',
    '9316': 'Sparekassen Kronjylland',
    '9317': 'Sparekassen Kronjylland',
    '9318': 'Sparekassen Kronjylland',
    '9319': 'Sparekassen Kronjylland',
    '9320': 'Sparekassen Kronjylland',
    '9321': 'Sparekassen Kronjylland',
    '9322': 'Sparekassen Kronjylland',
    '9323': 'Sparekassen Kronjylland',
    '9324': 'Sparekassen Kronjylland',
    '9325': 'Sparekassen Kronjylland',
    '9326': 'Sparekassen Kronjylland',
    '9328': 'Sparekassen Kronjylland',
    '9329': 'Sparekassen Kronjylland',
    '9330': 'Sparekassen Kronjylland',
    '9331': 'Sparekassen Kronjylland',
    '9332': 'Sparekassen Kronjylland',
    '9333': 'Sparekassen Kronjylland',
    '9334': 'Sparekassen Kronjylland',
    '9335': 'Sparekassen Kronjylland',
    '9336': 'Jutlander Bank',
    '9337': 'Sparekassen Hobro',
    '9338': 'Sparekassen Hobro',
    '9339': 'Sparekassen Hobro',
    '9340': 'Sparekassen Hobro',
    '9341': 'Sparekassen Hobro',
    '9342': 'Spar Nord',
    '9343': 'Danske Bank',
    '9344': 'Danske Bank',
    '9345': 'Spar Nord',
    '9346': 'Spar Nord',
    '9347': 'Spar Nord',
    '9348': 'Spar Nord',
    '9349': 'Spar Nord',
    '9351': 'Jutlander Bank',
    '9352': 'Sparekassen Hobro',
    '9353': 'Danske Bank',
    '9354': 'Rønde og Omegns Sparekasse',
    '9355': 'Mørke Sparekasse',
    '9356': 'Agri-Egens Sparekasse',
    '9357': 'Helgenæs Sparekasse',
    '9358': 'Vistoft Sparekasse',
    '9359': 'Spar Nord',
    '9360': 'Sparekassen Kronjylland',
    '9361': 'Sparekassen Kronjylland',
    '9362': 'Sparekassen Kronjylland',
    '9363': 'Sparekassen Hobro',
    '9364': 'Sparekassen Kronjylland',
    '9365': 'Sparekassen Kronjylland',
    '9366': 'Spar Nord',
    '9367': 'Spar Nord',
    '9368': 'Sparekassen Kronjylland',
    '9369': 'Søby-Skader-Halling Sparekasse',
    '9370': 'Spar Nord',
    '9371': 'Sparekassen Kronjylland',
    '9373': 'Sparekassen Kronjylland',
    '9374': 'Spar Nord',
    '9376': 'Sparekassen Kronjylland',
    '9377': 'Sparekassen Midtdjurs',
    '9378': 'Spar Nord',
    '9380': 'Spar Nord',
    '9381': 'Sparekassen Kronjylland',
    '9383': 'Spar Nord',
    '9385': 'Spar Nord',
    '9387': 'Spar Nord',
    '9388': 'Sparekassen Djursland',
    '9395': 'Sparekassen Kronjylland',
    '9402': 'Danske Bank',
    '9404': 'Danske Bank',
    '9407': 'Nordea',
    '9410': 'Nordea',
    '9412': 'Nordea',
    '9416': 'Nordea',
    '9417': 'Nordea',
    '9420': 'Nordea',
    '9421': 'Nordea',
    '9422': 'Nordea',
    '9423': 'Nordea',
    '9424': 'Nordea',
    '9425': 'Nordea',
    '9426': 'Nordea',
    '9427': 'Nordea',
    '9428': 'Nordea',
    '9433': 'Nordea',
    '9436': 'Sparekassen Hobro',
    '9439': 'Danske Bank',
    '9442': 'Danske Bank',
    '9444': 'Danske Bank',
    '9445': 'Danske Bank',
    '9447': 'Danske Bank',
    '9451': 'Danske Bank',
    '9452': 'Danske Bank',
    '9455': 'Danske Bank',
    '9456': 'Danske Bank',
    '9458': 'Danske Bank',
    '9459': 'Danske Bank',
    '9462': 'Danske Bank',
    '9463': 'Danske Bank',
    '9464': 'Danske Bank',
    '9465': 'Danske Bank',
    '9467': 'Danske Bank',
    '9468': 'Danske Bank',
    '9470': 'Danske Bank',
    '9472': 'Danske Bank',
    '9473': 'Danske Bank',
    '9474': 'Danske Bank',
    '9479': 'Danske Bank',
    '9480': 'Danske Bank',
    '9481': 'Danske Bank',
    '9482': 'Danske Bank',
    '9483': 'Danske Bank',
    '9484': 'Danske Bank',
    '9485': 'Danske Bank',
    '9486': 'Danske Bank',
    '9488': 'Danske Bank',
    '9490': 'Danske Bank',
    '9491': 'Danske Bank',
    '9493': 'Danske Bank',
    '9496': 'Danske Bank',
    '9499': 'Danske Bank',
    '9501': 'Fruering-Vitved Sparekasse',
    '9505': 'Danske Bank',
    '9506': 'Danske Bank',
    '9507': 'Danske Bank',
    '9508': 'Danske Bank',
    '9509': 'Danske Bank',
    '9510': 'Danske Bank',
    '9511': 'Danske Bank',
    '9512': 'Danske Bank',
    '9513': 'Danske Bank',
    '9514': 'Danske Bank',
    '9515': 'Danske Bank',
    '9517': 'Danske Bank',
    '9518': 'Danske Bank',
    '9519': 'Danske Bank',
    '9521': 'Danske Bank',
    '9522': 'Danske Bank',
    '9524': 'Danske Bank',
    '9525': 'Danske Bank',
    '9528': 'Danske Bank',
    '9530': 'Danske Bank',
    '9532': 'Danske Bank',
    '9536': 'Danske Bank',
    '9537': 'Danske Bank',
    '9538': 'Danske Bank',
    '9539': 'Danske Bank',
    '9541': 'Danske Bank',
    '9543': 'Danske Bank',
    '9544': 'Danske Bank',
    '9545': 'Danske Bank',
    '9547': 'Danske Bank',
    '9551': 'Den Jyske Sparekasse',
    '9552': 'Danske Bank',
    '9554': 'Danske Bank',
    '9556': 'Danske Bank',
    '9557': 'Nordea',
    '9559': 'Nordea',
    '9560': 'Den Jyske Sparekasse',
    '9561': 'Den Jyske Sparekasse',
    '9562': 'Danske Bank',
    '9568': 'Danske Bank',
    '9569': 'Danske Bank',
    '9570': 'Danske Bank',
    '9571': 'Danske Bank',
    '9573': 'Danske Bank',
    '9577': 'Danske Bank',
    '9578': 'Danske Bank',
    '9580': 'Danske Bank',
    '9581': 'Danske Bank',
    '9582': 'Danske Bank',
    '9583': 'Danske Bank',
    '9584': 'Danske Bank',
    '9585': 'Nordea',
    '9587': 'Nordea',
    '9588': 'Nordea',
    '9589': 'Nordea',
    '9590': 'Nordea',
    '9593': 'Nordea',
    '9595': 'Nordea',
    '9598': 'Nordea',
    '9600': 'Nordea',
    '9602': 'Nordea',
    '9604': 'Nordea',
    '9605': 'Nordea',
    '9606': 'Nordea',
    '9607': 'Nordea',
    '9608': 'Nordea',
    '9609': 'Nordea',
    '9610': 'Nordea',
    '9611': 'Nordea',
    '9612': 'Nordea',
    '9613': 'Nordea',
    '9614': 'Nordea',
    '9615': 'Nordea',
    '9617': 'Nordea',
    '9619': 'Nordea',
    '9620': 'Nordea',
    '9621': 'Nordea',
    '9622': 'Nordea',
    '9623': 'Nordea',
    '9624': 'Nordea',
    '9625': 'Nordea',
    '9626': 'Nordea',
    '9627': 'Ulfborg Sparekasse',
    '9628': 'Danske Bank',
    '9629': 'Stadil Sparekasse',
    '9630': 'Nordea',
    '9631': 'Den Jyske Sparekasse',
    '9632': 'Nordea',
    '9633': 'Nordea',
    '9634': 'Borbjerg Sparekasse',
    '9635': 'Nordea',
    '9637': 'Nordea',
    '9638': 'Nordea',
    '9641': 'Nordea',
    '9642': 'Nordea',
    '9643': 'Nordea',
    '9644': 'Nordea',
    '9647': 'Danske Bank',
    '9648': 'Nordea',
    '9649': 'Nordea',
    '9658': 'Danske Bank',
    '9659': 'Danske Bank',
    '9660': 'Danske Bank',
    '9661': 'Danske Bank',
    '9662': 'Danske Bank',
    '9663': 'Danske Bank',
    '9664': 'Danske Bank',
    '9665': 'Danske Bank',
    '9669': 'Danske Bank',
    '9670': 'Danske Bank',
    '9672': 'Danske Bank',
    '9674': 'Danske Bank',
    '9675': 'Danske Bank',
    '9676': 'Danske Bank',
    '9677': 'Danske Bank',
    '9678': 'Danske Bank',
    '9680': 'Danske Bank',
    '9681': 'Danske Bank',
    '9682': 'Nørre Nebel Sparekasse (Sparnebel)',
    '9684': 'Fanø Sparekasse',
    '9686': 'Den Jyske Sparekasse',
    '9687': 'Den Jyske Sparekasse',
    '9689': 'Danske Bank',
    '9690': 'Vorbasse-Hejnsvig Sparekasse',
    '9691': 'Vorbasse-Hejnsvig Sparekasse',
    '9692': 'Danske Bank',
    '9693': 'Danske Bank',
    '9694': 'Saxo Privatbank',
    '9695': 'Alm. Brand Bank',
    '9698': 'Danske Bank',
    '9699': 'Danske Bank',
    '9700': 'Danske Bank',
    '9701': 'Danske Bank',
    '9704': 'Danske Bank',
    '9705': 'Danske Bank',
    '9706': 'Danske Bank',
    '9707': 'Danske Bank',
    '9709': 'Danske Bank',
    '9710': 'Danske Bank',
    '9711': 'Danske Bank',
    '9712': 'Den Jyske Sparekasse',
    '9713': 'Danske Bank',
    '9714': 'Danske Bank',
    '9716': 'Danske Bank',
    '9718': 'Danske Bank',
    '9720': 'Danske Bank',
    '9722': 'Danske Bank',
    '9724': 'Danske Bank',
    '9725': 'Danske Bank',
    '9726': 'Danske Bank',
    '9727': 'Danske Bank',
    '9729': 'Danske Bank',
    '9731': 'Danske Bank',
    '9733': 'Frøs Herreds Sparekasse',
    '9734': 'Frøs Herreds Sparekasse',
    '9735': 'Frøs Herreds Sparekasse',
    '9736': 'Frøs Herreds Sparekasse',
    '9737': 'Frøs Herreds Sparekasse',
    '9738': 'Frøs Herreds Sparekasse',
    '9739': 'Frøs Herreds Sparekasse',
    '9740': 'Frøs Herreds Sparekasse',
    '9741': 'Frøs Herreds Sparekasse',
    '9742': 'Frøs Herreds Sparekasse',
    '9743': 'Danske Bank',
    '9745': 'Danske Bank',
    '9748': 'Danske Bank',
    '9749': 'Danske Bank',
    '9750': 'Danske Bank',
    '9752': 'Danske Bank',
    '9756': 'Danske Bank',
    '9757': 'Danske Bank',
    '9758': 'Danske Bank',
    '9762': 'Danske Bank',
    '9767': 'Danske Bank',
    '9768': 'Danske Bank',
    '9769': 'Danske Bank',
    '9770': 'Danske Bank',
    '9797': 'Broager Sparekasse',
    '9800': 'Danske Bank',
    '9803': 'Danske Bank',
    '9805': 'Jutlander Bank',
    '9806': 'Jutlander Bank',
    '9807': 'Jutlander Bank',
    '9809': 'Jutlander Bank',
    '9811': 'Spar Nord',
    '9812': 'Jutlander Bank',
    '9813': 'Jutlander Bank',
    '9814': 'Jutlander Bank',
    '9815': 'Spar Nord',
    '9817': 'Spar Nord',
    '9818': 'Spar Nord',
    '9819': 'Spar Nord',
    '9823': 'Den Jyske Sparekasse',
    '9824': 'Den Jyske Sparekasse',
    '9825': 'Danske Bank',
    '9826': 'Danske Bank',
    '9827': 'Sparekassen Bredebro',
    '9828': 'Tønder Sparekasse',
    '9838': 'Jutlander Bank',
    '9839': 'Skærbæk Sparekasse',
    '9846': 'Danske Bank',
    '9851': 'Jutlander Bank',
    '9852': 'Jutlander Bank',
    '9853': 'Sparekassen Thy',
    '9859': 'Sparekassen Thy',
    '9860': 'Folkesparekassen',
    '9865': 'Nordoya Sparikassi',
    '9870': 'Suduroyar Sparikassi',
    '9872': 'Spar Nord',
    '9873': 'Spar Nord',
    '9874': 'Banknordik',
    '9876': 'Danske Bank',
    '9877': 'Danske Bank',
    '9878': 'Danske Bank',
    '9880': 'Sparekassen Sjælland',
    '9881': 'Sparekassen Sjælland',
    '9882': 'Sparekassen Sjælland',
    '9883': 'Sparekassen Sjælland',
    '9884': 'Sparekassen Sjælland',
    '9885': 'Sparekassen Sjælland',
    '9886': 'Sparekassen Sjælland',
    '9887': 'Sparekassen Sjælland',
    '9888': 'Sparekassen Sjælland',
    '9889': 'Sparekassen Sjælland',
    '9890': 'Banknordik',
    '9891': 'Banknordik',
    '9892': 'Banknordik',
    '9893': 'Spar Nord',
    '9894': 'Spar Nord',
    '9895': 'Spar Nord',
    '9896': 'Spar Nord',
    '9897': 'Spar Nord',
    '9898': 'Spar Nord',
    '9899': 'Banknordik',
    '9942': 'Diba Bank',
    '9960': 'Forvaltningsinstituttet for Lokale Pengeinstitutter',
};
//# sourceMappingURL=banks.js.map